import React, { Fragment } from "react";
import { observer, inject } from "mobx-react";
import { Modal, Button, List, Switch, InputItem, Toast } from "antd-mobile";
import { AddonFixed, AddonSummary, RenderAddon, RenderNotes } from "./Addon";
import { FiShoppingCart, FiEdit } from "react-icons/fi";
import CircularProgressbar from "react-circular-progressbar";
import PromptPopup from "./Popup";
import _ from "underscore";
import "../cart.css";
import "react-circular-progressbar/dist/styles.css";
import {
  FaPaperclip,
  FaTrashAlt,
  FaCheckCircle,
  FaTimesCircle,
  FaPlus,
} from "react-icons/fa";
import PaymentOption from "./Payment/PaymentOption";
import FoodStepper from "./FoodStepper";
import PostQuestions from "./ActionQuestions";
import Recomendations from "./Recomendations";
import API from "../libs/api";
import configParam from "../libs/params";
import request from "../libs/request";
// request from "../libs/request";
import CheckBill from "./CheckBill";
import PowerBy from "./PowerBy";
import { Icon } from "antd";
import { throttle } from "lodash";

const alert = Modal.alert;
const prompt = Modal.prompt;
const Item = List.Item;
const Brief = Item.Brief;

const COUNTDOWN_LIMIT = 3;
let countdownTimer;
let cancelCheckout;
let intervalSeconds = [2, 3, 3, 3, 3, 3, 3, 3, 5];

@inject("cartStore")
@observer
class Cart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // Prompt popup
      campaignBalances: [], // Initialize as empty
      selectedCampaign: null, // To track the selected campaign
      selectedRedeem: null, // To track the selected redeem option
      rebateAmount: "", // To track the amount user wants to use for rebate/cashback
      closePopup: [],
      timeCountdown: COUNTDOWN_LIMIT,
      promptPopup: false,
      promptTitle: "",
      promptContent:
        this.props.cartStore.menuStore.translation.cart_preparing_order,
      promptLoading: true,
      verificationCode: null,
      checked: this.props.cartStore.menuStore.takeaway === "2" ? true : false,
      payLoad: "",
      promocode: "",
      promoPopup: false,
      //htmlMsg:false,
      //distance: this.props.cartStore.menuStore.location.areaLimit
    };
    this.props.cartStore.takeAway = this.state.checked;
  }
  componentDidMount() {
    const { cartStore } = this.props;
    const { menuStore } = cartStore;
    
    // Check if advocado token is valid
    if (!menuStore.isAdvocadoTokenValid()) {
      // Token is expired or invalid - clear data and show login modal
      menuStore.clearExpiredToken();
      
      // Only show login modal if membership account is enabled and socialCheckout is true
      const enableMembershipAccount = localStorage.getItem(
        `${menuStore.controller}_enable_membership_account`
      ) === 'true';
      if (enableMembershipAccount && menuStore.socialCheckout === true) {
        menuStore.isLoginModalVisible = true;
        console.log('Token expired or invalid, showing login modal (membership enabled + socialCheckout)');
      } else {
        console.log('Token expired but not showing login modal (membership disabled or socialCheckout false)');
      }
    } else {
      // Token is valid, proceed with campaign updates
      const token = localStorage.getItem(
        `${menuStore.controller}_advocado_token`
      );
      const controller = menuStore.controller;
      
      // Add any additional conditions as needed.
      if (token && controller /* && otherCondition */) {
        this.fetchCampaignsAndUpdate();
      }
      
    }
    const paymentRes = localStorage.getItem(
      `${this.props.cartStore.menuStore.controller}_payment`
    );
    if (paymentRes) {
      localStorage.removeItem("is_opened_post_question");
      let paymentDetails = JSON.parse(paymentRes);

      /* if(paymentDetails.status === 'cancel' )
      {
        paymentDetails.msg="";
        this._openEmailMessage(paymentDetails);
      }
      else{*/
      this._startOrderProcessing(paymentDetails);
      // }
      /* let partnerTXID = localStorage.getItem(`${this.props.cartStore.menuStore.controller}_partnerTX`);
    //  let tAccessToekn = localStorage.getItem(`${this.props.cartStore.menuStore.controller}_accessToken`);
    //  let is_sandbox = localStorage.getItem(`${this.props.cartStore.menuStore.controller}_sandbox`);
      let userInfo = localStorage.getItem(`${this.props.cartStore.menuStore.controller}_userinfo`);
      let receipt = localStorage.getItem(`${this.props.cartStore.menuStore.controller}_receipt`);
      let cId = this.props.cartStore.menuStore.controller + '--';
      if (userInfo !== "") {
        userInfo = JSON.parse(userInfo);
      }
      if (receipt !== "") {
        receipt = JSON.parse(receipt);
      }
      let cartLength = this.props.cartStore.entries.length;
      if (cartLength > 0 && paymentDetails.method === 'grab_online' && paymentDetails.status === 1) {  // && 
        this._startOrderProcessing(paymentDetails);
      }
      else if (cartLength > 0 && paymentDetails.method === 't05pay' && paymentDetails.status === 'success' ) {
        this._startOrderProcessing(paymentDetails);
      }
      else if (cartLength > 0 && paymentDetails.method === 'eghl' && paymentDetails.status === 'success' ) { 
        this._startOrderProcessing(paymentDetails);
      }
      else if (cartLength > 0 && paymentDetails.method === 'ipay88' && paymentDetails.status === 'success' ) {     
        this._startOrderProcessing(paymentDetails);
      }
      else {
        alert(
          this.props.cartStore.menuStore.translation.payment_status,
          paymentDetails.msg ? paymentDetails.msg : this.props.cartStore.menuStore.translation.payment_msg + '\n Order Id:' + paymentDetails.refno,
          [
            {
              text: this.props.cartStore.menuStore.translation.send_emil,
              onPress: () => {
                let msg = this.props.cartStore.menuStore.translation.email_error;
                this.setState({ tablePopup: false });
                API.sendEmail(paymentRes)
                  .then(res => {

                    if (res.status === 'success') {
                      msg = this.props.cartStore.menuStore.translation.email_sent;
                    }

                    alert(msg, null, [
                      { text: "Close", onPress: () => { } }
                    ]);
                  })
                  .catch(err => {
                    alert(msg, null, [
                      { text: "Close", onPress: () => { } }
                    ]);
                  });
              }
            },
            {
              text: this.props.cartStore.menuStore.translation.close,
              onPress: () => {
                this.setState({
                  tablePopup: false
                });
              }
            }
          ]
        );
      }
      localStorage.removeItem(`${this.props.cartStore.menuStore.controller}_partnerTX`);
     
      localStorage.removeItem(`${this.props.cartStore.menuStore.controller}_userinfo`);
      localStorage.removeItem(`${this.props.cartStore.menuStore.controller}_receipt`);*/
      localStorage.removeItem(
        `${this.props.cartStore.menuStore.controller}_payment`
      );
    }
    localStorage.removeItem("hideMenu");
    /* else if(this.props.cartStore.entries.length > 0 && this.props.cartStore.menuStore.location.areaLimit>0) {
       this._getLocation();
     }*/
  }

  calculateBalance(campaign, rewards) {
    const matchedReward = rewards.find(
      (reward) => reward.campaignId === campaign.id
    );
    if (!matchedReward) return "N/A";

    switch (matchedReward.campaignType) {
      case "loyalty":
        return matchedReward.points || "N/A";
      case "stamps":
        return matchedReward.stamps || "N/A";
      case "stored-value":
        return matchedReward.values || "N/A";
      case "cashback":
        return matchedReward.amounts || "N/A";
      case "voucher":
        return matchedReward.vouchers || "N/A";
      default:
        return "Unknown";
    }
  }

  fetchCampaignsAndUpdate = async () => {
    try {
      // Retrieve the token and controller
      const token = localStorage.getItem(
        `${this.props.cartStore.menuStore.controller}_advocado_token`
      );
      const controller = this.props.cartStore.menuStore.controller;

      // Get customer info for fresh campaignBalances
      const social = this.props.cartStore.menuStore.social || {};
      const phoneNumber = social.phoneNumber;
      const countryCode = social.countryCallingCode || "+65"; // fallback to Singapore

      if (!token) {
        console.warn("Token not found, skipping campaign refresh");
        return;
      }
      if (!controller) {
        console.warn("Controller missing, skipping campaign refresh");
        return;
      }
      if (!phoneNumber) {
        console.warn("Phone number not found, skipping campaign refresh");
        return;
      }

// console.log("Fetching fresh customer data...");

      // Get fresh customer data with updated campaignBalances
      const customerResponse = await request.get(
        `${configParam.advocadoBaseUrl}/customers/phone-number/${countryCode}/${phoneNumber}/compact`,
        undefined,
        {
          Authorization: `Bearer ${token}`,
          controller: controller,
        }
      );

// console.log("Customer response:", customerResponse);

      if (customerResponse.code !== 200) {
        console.error(
          "Customer API error:",
          customerResponse.code,
          customerResponse.message
        );
        // Log the user out when the API returns non-200 status
        this.props.cartStore.menuStore.logout();
        return;
      }

      const customerData = customerResponse.data;

      // Check if this is valid customer data - but don't treat newCustomer as error
      if (customerData.newCustomer === 1) {
        console.warn("Customer data shows newCustomer flag, but continuing...");
        // Don't throw error here, continue with existing data
      }

// console.log("Fetching campaigns data...");

      // Get fresh campaigns data to match with customer balances
      const campaignsResponse = await request.get(
        configParam.advocadoRewardsUrl,
        undefined,
        {
          Authorization: `Bearer ${token}`,
          controller: controller,
        }
      );

// console.log("Campaigns response:", campaignsResponse);

      if (
        campaignsResponse.code !== 200 ||
        campaignsResponse.status !== "success"
      ) {
        console.error(
          "Campaigns API error:",
          campaignsResponse.code,
          campaignsResponse.status
        );
        // Don't logout for temporary API issues
        return;
      }

      const fetchedCampaigns = campaignsResponse.data;
      const campaignBalances = customerData.campaignBalances || [];

      // console.log("Processing campaigns...", {
      //   fetchedCampaigns,
      //   campaignBalances,
      // });

      // Process all campaigns with their balances
      const allCampaigns = fetchedCampaigns.map((campaign) => ({
        ...campaign,
        balance: this.calculateBalance(campaign, campaignBalances),
      }));

      // Filtered campaigns (only those with balance)
      const processedCampaigns = allCampaigns.filter(
        (campaign) => campaign.balance !== "N/A"
      );

      // Update the social data with all campaigns and balances
      if (this.props.cartStore.menuStore.social) {
        const social = this.props.cartStore.menuStore.social;

        // Update campaignBalances
        social.campaignBalances = campaignBalances;

        // Store all campaigns data
        social.allCampaigns = allCampaigns;

        // Also store a timestamp for the last update
        social.campaignsLastUpdated = new Date().toISOString();

        // Update localStorage to persist the changes
        const storageKey = `${this.props.cartStore.menuStore.controller}_social`;
        localStorage.setItem(storageKey, JSON.stringify(social));

        // console.log("Updated social data with campaigns:", {
        //   allCampaigns,
        //   campaignBalances,
        //   storageKey,
        // });
      }

      this.setState({ campaignBalances: processedCampaigns });
      // console.log("Campaign refresh completed successfully");
    } catch (error) {
      console.error("Error in fetchCampaignsAndUpdate:", error);

      // Only logout on authentication errors, not on network/temporary issues
      if (
        error.message &&
        (error.message.includes("401") ||
          error.message.includes("Unauthorized") ||
          error.message.includes("Token") ||
          error.message.includes("Authentication"))
      ) {
        this.props.cartStore.menuStore.logout();
      } else {
        console.warn(
          "Temporary error fetching campaigns, keeping session:",
          error.message
        );
        // Just show a less intrusive message
        // alert("Could not refresh rewards. Please try again later.");
      }
    }
  };

  applyCampaign = async (campaignId, redeemId = null) => {
    // console.log('[Rewards Debug][applyCampaign] called', { campaignId, redeemId });
    const { campaignBalances = [] } = this.state;
    const selectedCampaign = campaignBalances.find((c) => c.id === campaignId);

    if (!selectedCampaign) {
      console.warn(`[applyCampaign] Campaign not found for ID: ${campaignId}`);
      Toast.fail("Please select a valid campaign.");
      return;
    }

    // Check if PIN authentication is required
    if (selectedCampaign.authentication === "Redemption Pin Required") {
      // Get social data from localStorage
      const socialData = JSON.parse(
        localStorage.getItem(
          `${this.props.cartStore.menuStore.controller}_social`
        )
      );
      // console.log("socialData", socialData);
      if (!socialData || !socialData.id) {
        Toast.fail("Customer information not found. Please login again.");
        return;
      }

      // Show PIN prompt modal
      Modal.prompt(
        "Enter PIN",
        <div>
          <p style={{ marginBottom: 8 }}>
            Please enter your PIN to redeem this reward
          </p>
          <span
            className="forgot-pin-link"
            style={{
              display: "inline-block",
              fontSize: "13px",
              color: "#1a5632",
              marginBottom: 8,
              cursor: "pointer",
              textDecoration: "underline",
              background: "none",
              border: "none",
              padding: 0,
              transition: "color 0.2s",
            }}
            onClick={async () => {
              try {
                const response = await request.post(
                  `${configParam.advocadoBaseUrl}/customers/forget-pin`,
                  JSON.stringify({
                    customerId: socialData.id,
                    countryCallingCode: socialData.countryCallingCode,
                    phoneNumber: socialData.phoneNumber,
                  }),
                  {
                    "Content-Type": "application/json",
                    controller: this.props.cartStore.menuStore.controller,
                    Authorization: `Bearer ${localStorage.getItem(
                      `${this.props.cartStore.menuStore.controller}_advocado_token`
                    )}`,
                  }
                );
                if (response.code === 200) {
                  Toast.success("PIN reset instructions have been sent");
                } else if (
                  response.code === 501 &&
                  response.data &&
                  Array.isArray(response.data)
                ) {
                  const errorMessages = response.data
                    .map((error) => error.msg)
                    .join("\n");
                  Toast.fail(errorMessages);
                } else {
                  Toast.fail("Failed to process PIN reset request");
                }
              } catch (error) {
                console.error("PIN Reset Error:", error);
                Toast.fail("Failed to process PIN reset request");
              }
            }}
          >
            Forgot PIN?
          </span>
        </div>,
        [
          { text: "Cancel", style: "default" },
          {
            text: "Submit",
            onPress: async (pin) => {
              if (!pin || pin.trim() === "") {
                Toast.fail("Please enter a valid PIN");
                return;
              }

              try {
                const response = await request.post(
                  `https://api.advocadoapp.com/api/v1.1/customers/verify-pin`,
                  JSON.stringify({
                    customerId: socialData.id,
                    pin: pin.trim(),
                  }),
                  {
                    "Content-Type": "application/json",
                    controller: this.props.cartStore.menuStore.controller,
                    Authorization: `Bearer ${localStorage.getItem(
                      `${this.props.cartStore.menuStore.controller}_advocado_token`
                    )}`,
                  }
                );

                if (response.code === 200) {
                  if (response.data === true) {
                    // PIN is correct, proceed with reward application
                    // Save PIN to social data in localStorage
                    // Update both localStorage and MenuStore's social state
                    const updatedSocial = {
                      ...this.props.cartStore.menuStore.social,
                      pin: pin,
                    };

                    // Update MenuStore's social state
                    this.props.cartStore.menuStore.social = updatedSocial;

                    // Update localStorage
                    const storageKey = `${this.props.cartStore.menuStore.controller}_social`;
                    localStorage.setItem(
                      storageKey,
                      JSON.stringify(updatedSocial)
                    );

                    // Log the update
                    // console.log("Updated social data with PIN:", {
                    //   storageKey,
                    //   updatedSocial: this.props.cartStore.menuStore.social,
                    //   storedData: JSON.parse(localStorage.getItem(storageKey)),
                    // });
                    this.processRewardApplication(selectedCampaign, redeemId);
                  } else {
                    Toast.fail("Invalid PIN. Please try again.");
                  }
                } else {
                  Toast.fail("Invalid PIN. Please try again.");
                }
              } catch (error) {
                console.error("PIN Verification Error:", error);
                Toast.fail("Failed to verify PIN. Please try again.");
              }
            },
          },
        ],
        "secure-text"
      );
    } else {
      // No PIN required, proceed directly
      // console.log('[Rewards Debug][applyCampaign] No PIN required -> processRewardApplication');
      this.processRewardApplication(selectedCampaign, redeemId);
    }
  };

  // New method to handle rebate/cashback with custom amount
  applyCampaignWithRebateAmount = async (campaignId, rebateAmount) => {
    // console.log('[Rewards Debug][applyCampaignWithRebateAmount] called', { campaignId, rebateAmount });
    const { campaignBalances = [] } = this.state;
    const selectedCampaign = campaignBalances.find((c) => c.id === campaignId);

    if (!selectedCampaign) {
      console.warn(
        `[applyCampaignWithRebateAmount] Campaign not found for ID: ${campaignId}`
      );
      Toast.fail("Please select a valid campaign.");
      return;
    }

    // Create a modified campaign object with the custom rebate amount
    const modifiedCampaign = {
      ...selectedCampaign,
      balance: rebateAmount,
      customRebateAmount: rebateAmount,
    };
    // console.log('[Rewards Debug][applyCampaignWithRebateAmount] modifiedCampaign', modifiedCampaign);

    // Check if PIN authentication is required
    if (selectedCampaign.authentication === "Redemption Pin Required") {
      // Get social data from localStorage
      const socialData = JSON.parse(
        localStorage.getItem(
          `${this.props.cartStore.menuStore.controller}_social`
        )
      );
      // console.log("socialData", socialData);
      if (!socialData || !socialData.id) {
        Toast.fail("Customer information not found. Please login again.");
        return;
      }

      // Show PIN prompt modal
      Modal.prompt(
        "Enter PIN",
        <div>
          <p style={{ marginBottom: 8 }}>
            Please enter your PIN to redeem ${rebateAmount.toFixed(2)} from your{" "}
            {selectedCampaign.type === "cashback" ? "cashback" : "stored value"}
          </p>
          <span
            className="forgot-pin-link"
            style={{
              display: "inline-block",
              fontSize: "13px",
              color: "#1a5632",
              marginBottom: 8,
              cursor: "pointer",
              textDecoration: "underline",
              background: "none",
              border: "none",
              padding: 0,
              transition: "color 0.2s",
            }}
            onClick={async () => {
              try {
                const response = await request.post(
                  `${configParam.advocadoBaseUrl}/customers/forget-pin`,
                  JSON.stringify({
                    customerId: socialData.id,
                    countryCallingCode: socialData.countryCallingCode,
                    phoneNumber: socialData.phoneNumber,
                  }),
                  {
                    "Content-Type": "application/json",
                    controller: this.props.cartStore.menuStore.controller,
                    Authorization: `Bearer ${localStorage.getItem(
                      `${this.props.cartStore.menuStore.controller}_advocado_token`
                    )}`,
                  }
                );
                if (response.code === 200) {
                  Toast.success("PIN reset instructions have been sent");
                } else if (
                  response.code === 501 &&
                  response.data &&
                  Array.isArray(response.data)
                ) {
                  const errorMessages = response.data
                    .map((error) => error.msg)
                    .join("\n");
                  Toast.fail(errorMessages);
                } else {
                  Toast.fail("Failed to process PIN reset request");
                }
              } catch (error) {
                console.error("PIN Reset Error:", error);
                Toast.fail("Failed to process PIN reset request");
              }
            }}
          >
            Forgot PIN?
          </span>
        </div>,
        [
          { text: "Cancel", style: "default" },
          {
            text: "Submit",
            onPress: async (pin) => {
              if (!pin || pin.trim() === "") {
                Toast.fail("Please enter a valid PIN");
                return;
              }

              try {
                const response = await request.post(
                  `https://api.advocadoapp.com/api/v1.1/customers/verify-pin`,
                  JSON.stringify({
                    customerId: socialData.id,
                    pin: pin.trim(),
                  }),
                  {
                    "Content-Type": "application/json",
                    controller: this.props.cartStore.menuStore.controller,
                    Authorization: `Bearer ${localStorage.getItem(
                      `${this.props.cartStore.menuStore.controller}_advocado_token`
                    )}`,
                  }
                );

                if (response.code === 200) {
                  if (response.data === true) {
                    // PIN is correct, proceed with reward application
                    // Save PIN to social data in localStorage
                    // Update both localStorage and MenuStore's social state
                    const updatedSocial = {
                      ...this.props.cartStore.menuStore.social,
                      pin: pin,
                    };

                    // Update MenuStore's social state
                    this.props.cartStore.menuStore.social = updatedSocial;

                    // Update localStorage
                    const storageKey = `${this.props.cartStore.menuStore.controller}_social`;
                    localStorage.setItem(
                      storageKey,
                      JSON.stringify(updatedSocial)
                    );

                    // Log the update
                    // console.log("Updated social data with PIN:", {
                    //   storageKey,
                    //   updatedSocial: this.props.cartStore.menuStore.social,
                    //   storedData: JSON.parse(localStorage.getItem(storageKey)),
                    // });
                    this.processRewardApplication(modifiedCampaign);
                  } else {
                    Toast.fail("Invalid PIN. Please try again.");
                  }
                } else {
                  Toast.fail("Invalid PIN. Please try again.");
                }
              } catch (error) {
                console.error("PIN Verification Error:", error);
                Toast.fail("Failed to verify PIN. Please try again.");
              }
            },
          },
        ],
        "secure-text"
      );
    } else {
      // No PIN required, proceed directly
      // console.log('[Rewards Debug][applyCampaignWithRebateAmount] No PIN required -> processRewardApplication');
      this.processRewardApplication(modifiedCampaign);
    }
  };

  processRewardApplication = (selectedCampaign, redeemId) => {
    // console.log('[Rewards Debug][processRewardApplication] start', { selectedCampaign, redeemId });
    // Prepare reward object and alert message.
    let rewardToApply = { ...selectedCampaign };
    let alertMessage = `Campaign "${selectedCampaign.name}" applied successfully!`;

    // Handle redeem selection if redeem options exist.
    if (selectedCampaign.redeem) {
      if (!redeemId) {
        console.warn(
          `[applyCampaign] Redeem option not provided for campaign ${selectedCampaign.id}`
        );
        Toast.fail("Please select a valid redeem option.");
        return;
      }
      const selectedRedeem = selectedCampaign.redeem.find(
        (redeem) => redeem.id === redeemId
      );
      if (!selectedRedeem) {
        console.warn(
          `[applyCampaign] Redeem option not found for ID: ${redeemId}`
        );
        Toast.fail("Please select a valid redeem option.");
        return;
      }
      rewardToApply.selectedRedeem = selectedRedeem;
      alertMessage += `\nRedeem Option: "${
        selectedRedeem.description || selectedRedeem.value || redeemId
      }"`;

      // For dollarValue rewards, ensure the discount does not exceed the cart total.
      if (selectedRedeem.type === "dollarValue") {
        const discountAmount = parseFloat(selectedRedeem.value || 0);
        const numericTotal =
          parseFloat(this.props.cartStore.appliedRewardDetails.baseTotal) || 0;
        if (discountAmount > numericTotal) {
          Toast.fail(
            `The discount of $${discountAmount.toFixed(
              2
            )} exceeds your cart total of $${numericTotal.toFixed(2)}.`
          );
          return;
        }
      }
    } else {
      // console.log("Campaign has no redeem options:", selectedCampaign);
      let discountAmount = 0;
      if (selectedCampaign.voucherType === "dollarValue") {
        discountAmount = parseFloat(selectedCampaign.voucherValue || 0);
        const numericTotal =
          parseFloat(this.props.cartStore.appliedRewardDetails.baseTotal) || 0;
        if (discountAmount > numericTotal) {
          Toast.fail(
            `The discount of $${discountAmount.toFixed(
              2
            )} exceeds your cart total of $${numericTotal.toFixed(2)}.`
          );
          return;
        }
      } else if (selectedCampaign.voucherType === "item") {
        // For item vouchers, check if the required item is in cart
        let hasRequiredItem = false;
        
        if (selectedCampaign.itemName) {
          hasRequiredItem = this.props.cartStore.entries.some(entry => 
            entry.item.name.toLowerCase().includes(selectedCampaign.itemName.toLowerCase()) ||
            (entry.item.sku && entry.item.sku.toLowerCase().includes(selectedCampaign.itemName.toLowerCase()))
          );
        }
        
        // Also check extSkuMapping if available
        if (!hasRequiredItem && selectedCampaign.extSkuMapping && Array.isArray(selectedCampaign.extSkuMapping)) {
          hasRequiredItem = this.props.cartStore.entries.some(entry => 
            selectedCampaign.extSkuMapping.some(skuMapping => {
              // Support both "sku" and "itemSku" properties
              const skuValue = skuMapping.sku || skuMapping.itemSku;
              return skuValue && entry.item.sku && 
                     entry.item.sku.toLowerCase() === skuValue.toLowerCase();
            })
          );
        }
        
        if (!hasRequiredItem) {
          const itemName = selectedCampaign.itemName || "required items";
          Toast.fail(
            `This voucher requires "${itemName}" to be in your cart.`
          );
          return;
        }
        
        // For item vouchers, calculate the actual discount amount that would be applied
        let actualDiscountAmount = 0;
        const numericTotal = parseFloat(this.props.cartStore.appliedRewardDetails.baseTotal) || 0;
        
        if (selectedCampaign.voucherRules && selectedCampaign.voucherRules.option === "itemOff") {
          // Lấy danh sách các entry phù hợp
          const matchedEntries = this.props.cartStore.entries.filter(entry => {
            let shouldApplyDiscount = false;
            if (selectedCampaign.itemName && 
                (entry.item.name.toLowerCase().includes(selectedCampaign.itemName.toLowerCase()) ||
                 (entry.item.sku && entry.item.sku.toLowerCase().includes(selectedCampaign.itemName.toLowerCase())))) {
              shouldApplyDiscount = true;
            }
            if (selectedCampaign.extSkuMapping && Array.isArray(selectedCampaign.extSkuMapping)) {
              const matchingSku = selectedCampaign.extSkuMapping.find(skuMapping => {
                const skuValue = skuMapping.sku || skuMapping.itemSku;
                return skuValue && entry.item.sku && 
                       entry.item.sku.toLowerCase() === skuValue.toLowerCase();
              });
              if (matchingSku) {
                shouldApplyDiscount = true;
              }
            }
            return shouldApplyDiscount;
          });

          // Sắp xếp các item phù hợp theo giá tăng dần, lấy item rẻ nhất trước
          matchedEntries.sort((a, b) => parseFloat(this.props.cartStore.entryTotal(a)) - parseFloat(this.props.cartStore.entryTotal(b)));
          // console.log('[Voucher Debug] matchedEntries:', matchedEntries.map(e => ({name: e.item.name, sku: e.item.sku, price: this.props.cartStore.entryTotal(e)})));
          let actualDiscountAmount = 0;
          if (matchedEntries.length > 0) {
            actualDiscountAmount = parseFloat(this.props.cartStore.entryTotal(matchedEntries[0]));
            // console.log('[Voucher Debug] Chosen item for discount:', matchedEntries[0].item.name, 'SKU:', matchedEntries[0].item.sku, 'Price:', this.props.cartStore.entryTotal(matchedEntries[0]));
          }
          // console.log('[Voucher Debug] Final discountAmount:', actualDiscountAmount);
        } else {
          // Fallback to voucherValue for item vouchers without specific rules
          actualDiscountAmount = parseFloat(selectedCampaign.voucherValue || 0);
        }
        
        // Update discountAmount for validation
        discountAmount = actualDiscountAmount;
      }
      // Validate minimum spend if voucherRules exist.
      const minSpend =
        selectedCampaign.voucherRules && selectedCampaign.voucherRules.minSpend
          ? parseFloat(selectedCampaign.voucherRules.minSpend)
          : 0;
      const numericTotal =
        parseFloat(this.props.cartStore.appliedRewardDetails.baseTotal) || 0;
      if (minSpend && numericTotal < minSpend) {
        Toast.fail(
          `This reward requires a minimum spend of $${minSpend.toFixed(2)}.`
        );
        return;
      }
    }

    // --- Enforce max 2 rewards and 1 per type ---
    // console.log('[Rewards Debug][processRewardApplication] enforcing limits', { currentSocial: this.props.cartStore.menuStore.social });
    const social = this.props.cartStore.menuStore.social || {};
    let existing = Array.from(social.appliedRewards || []);
    // Include legacy single redeem into the set for counting/types
    if (social.redeem) {
      const legacy = social.redeem;
      const legacyId = legacy.id || legacy.campaignId || legacy.redeem_code;
      const exists = existing.some((r) => {
        const rId = (r && (r.id || r.campaignId || r.redeem_code)) || "";
        return rId === legacyId;
      });
      if (!exists) existing.push(legacy);
    }

    const getCategory = (rw) => {
      const r = rw && (rw.selectedRedeem || rw);
      const t = r && r.type;
      if (t === "cashback" || t === "stored-value") return "rebate";
      if (t === "voucher" || (r && r.voucherType)) return "voucher";
      return t || "unknown";
    };

    const newReward = rewardToApply.selectedRedeem || rewardToApply;
    const newType = getCategory(newReward);
    const existingTypes = new Set(existing.map((r) => getCategory(r)));
    // console.log('[Rewards Debug][processRewardApplication] types', { newType, existingTypes: Array.from(existingTypes), existingCount: existing.length });

    if (existing.length >= 2 && !existingTypes.has(newType)) {
      Toast.fail("You can only apply up to 2 rewards");
      return;
    }
    // If same category exists, we'll replace it in store (allow switching)

    this.props.cartStore.applyReward(rewardToApply);
    // console.log('[Rewards Debug][processRewardApplication] applied. updated social', this.props.cartStore.menuStore.social);
    Toast.success(alertMessage);
  };

  checkSinglePaymentGateway(openSinglePaymentGateway) {
    this.callPymanetOptions = openSinglePaymentGateway;
  }
  _openEmailMessage(paymentRes) {
    //this.props.cartStore.orderStore.updateOrder(paymentRes,100);
    // console.log("_openEmailMessage paymentRes", paymentRes);
    let msg =
      paymentRes.msg && paymentRes.msg !== ""
        ? paymentRes.msg
        : this.props.cartStore.menuStore.translation.general_error; //
    paymentRes.code =
      !paymentRes.code || paymentRes.code === "" ? 6000 : paymentRes.code;
    msg = msg.replace("#ERROR CODE#", paymentRes.code);
    msg = msg.replace("#Order ID#", paymentRes.refno);

    let btns = [];
    btns.push({
      text: this.props.cartStore.menuStore.translation.close,
      onPress: () => {
        this._callCartStatusCheck(2);
      },
    });
    if (paymentRes.method === "yeahpay") {
      btns.push({
        text: this.props.cartStore.menuStore.translation.retry,
        onPress: () => {
          this._startGetPingStatusForYeahpay(0, paymentRes);
          this._startOrderProcessing(paymentRes);
        },
      });
    }
    if (paymentRes.code === 5011 || paymentRes.code === "5011") {
      btns.push({
        text: this.props.cartStore.menuStore.translation.try_again,
        onPress: () => {
          this._callCartStatusCheck(2);
          // this.props.cartStore.isValidPostQa = "retrypayment";
          localStorage.setItem("is_opened_post_question", "1");
          var evt = document.createEvent("Event");
          evt.initEvent("click", true, true);

          let ele = document.querySelector("#checkoutButton");
          ele.dispatchEvent(evt);
          ele.click();
          this.props.cartStore.menuStore.actionModalVisisble = "";
          //this.props.cartStore.menuStore.isValidPostQa = "retrypayment";
        },
      });
    }
    /*alert(
      this.props.cartStore.menuStore.translation.payment_error_title,
      msg,
      btns
    );*/
    this.setState({
      promptPopup: true,
      promptTitle:
        this.props.cartStore.menuStore.translation.payment_error_title,
      promptLoading: false,
      promptContent: "<div style=text-align:left;>" + msg + "</div>", //"To place order, SCAN the QR Code again.",
      closePopup: btns,
    });
  }
  /*checkPostQAy(postQA) {
        this.callQA = postQA;
    }*/

  _startOrderProcessing(payload) {
    if (payload.status && payload.status === "failed") {
      let errorMsg = payload.msg ? payload.msg : "";
      payload.msg = this.props.cartStore.menuStore.translation.payment_error;
      if (errorMsg !== "") {
        payload.msg += "\n" + errorMsg;
      }

      payload.code = "5011";
      this._openEmailMessage(payload);
    } else {
      this._callCartStatusCheck(1);
      //this._startGetPingStatus(0,payload,);
      this._callPaypalPaymentStatus(payload, "redirect");
    }

    /* this.props.cartStore.addOrderByBackend(payload.orderStatus);
    this.props.cartStore.tabHandler("order");
    this._callCheckOrderStatus(payload);*/
  }
  _callPaypalPaymentStatus = (payload, type) => {
    console.log('🔍 _callPaypalPaymentStatus - payload:', payload);
    console.log('🔍 _callPaypalPaymentStatus - type:', type);
    
    // Validate payload.refno format (should have timestamp prefix like "1760299376-0130")
    if (payload.refno && !payload.refno.includes('-')) {
      console.warn('⚠️ [_callPaypalPaymentStatus] Invalid refno format (missing timestamp):', payload.refno);
      console.log('⚠️ [_callPaypalPaymentStatus] Skipping addOrderByBackend for invalid order');
      // Don't add order with invalid ID
      // Just start polling if pingUrl exists
      if (payload.pingUrl) {
        if (payload.method === "yeahpay") {
          this._startGetPingStatusForYeahpay(0, payload);
        } else {
          this._startGetPingStatus(0, payload);
        }
      }
      return;
    }
    
    if (type !== "spot") {
      this.props.cartStore.addOrderByBackend(payload, "");
      this.props.cartStore.tabHandler("order");
    }
    if (payload.method === "yeahpay") {
      this._startGetPingStatusForYeahpay(0, payload);
    } else {
      this._startGetPingStatus(0, payload);
    }
  };
  _startGetPingStatus(ind, payload) {
    let timePoll = parseInt(intervalSeconds[ind]);
    if (ind >= intervalSeconds.length || timePoll === 0) {
      payload.code = 5002;
      this._openEmailMessage(payload);
      return;
    }
    // console.log(77);
    ind++;
    const { cartStore } = this.props;
    const obj = this;
    setTimeout(function () {
      // Validate pingUrl before calling API
      if (!payload.pingUrl || payload.pingUrl === 'undefined' || payload.pingUrl === 'null') {
        console.error('❌ PingUrl is undefined in payload:', payload);
        console.log('🔍 Full payload:', payload);
        obj._startGetPingStatus(ind, payload);
        return;
      }
      
      console.log('🔍 Calling getPingStaus with URL:', payload.pingUrl);
      API.getPingStaus(payload.pingUrl)
        .then((res) => {
          let orderCode = res.data;
          if (!res.data || orderCode === "" || orderCode === "undefined") {
            obj._startGetPingStatus(ind, payload);
          } else {
            let ordernum = orderCode.split(":");
            payload.code = ordernum[1];
            let eMsg = "";
            if (ordernum[2] && ordernum[2] !== "") {
              eMsg = " " + ordernum[2];
            }
            if (ordernum[0] && ordernum[0] === "success") {
              let tamount = cartStore.total;
              ind = intervalSeconds.length + 1;
              // cartStore.addOrderByBackend(orderCode);
              cartStore.addOrderByBackend(payload, ordernum[1]);
              cartStore.tabHandler("order");
              obj._callCheckOrderStatus(payload);
              cartStore.menuStore.sendGoogleAnalyticsOrder(
                tamount,
                ordernum[1]
              );
            } else if (
              ind < intervalSeconds.length &&
              (ordernum[0] === "started" || orderCode === "")
            ) {
              obj._startGetPingStatus(ind, payload);
            } else if (
              ordernum[1] &&
              ordernum[0] === "error" &&
              ordernum[1] === "5014"
            ) {
              payload.msg =
                cartStore.menuStore.translation.payment_cancel + eMsg;
              obj._openEmailMessage(payload);
            } else if (
              ordernum[1] &&
              ordernum[0] === "error" &&
              ordernum[1] === "5011"
            ) {
              payload.msg =
                cartStore.menuStore.translation.payment_error + eMsg;
              obj._openEmailMessage(payload);
            } else if (
              ordernum[1] &&
              ordernum[0] === "error" &&
              ordernum[1] === "5012"
            ) {
              let codenum = ordernum[1].split(":");
              payload.code = codenum[0];
              payload.msg = cartStore.menuStore.translation.gateway_error;
              payload.msg = payload.msg.replace("#MESSGE#", codenum[1]);
              obj._openEmailMessage(payload);
            } else if (ordernum[1] && ordernum[0] === "refund") {
              var msg = "";
              if (ordernum[1] === "7001") {
                msg = cartStore.menuStore.translation.refund_start;
              } else if (ordernum[1] === "7002") {
                msg = cartStore.menuStore.translation.refund_success;
              } else if (ordernum[1] === "7003") {
                msg = cartStore.menuStore.translation.refund_failed;
              }
              payload.msg = msg;
              obj._openEmailMessage(payload);
            } else {
              //// console.log(66,orderCode);
              payload.msg = eMsg;
              obj._openEmailMessage(payload);
            }
          }
        })
        .catch((err) => {
          // console.log(err);
          // console.log("--ping error-");
          obj._startGetPingStatus(ind, payload);
        });
    }, timePoll * 1000);
  }
  _startGetPingStatusForYeahpay(ind, payload) {
    // console.log("ind", ind);
    // console.log("ipayloadd", payload);
    let timePoll = parseInt(intervalSeconds[ind]);
    if (
      ind >= intervalSeconds.length ||
      timePoll === 0 ||
      payload.refId === ""
    ) {
      payload.code = "";
      payload.msg = "Payment Unknown";
      this._startGetPingStatus(0, payload);
      return;
    }
    // console.log(77);
    ind++;
    const { cartStore } = this.props;
    const obj = this;
    setTimeout(function () {
      API.getPingYeahpayStatus(cartStore.menuStore.controller, payload.refId)
        .then((res) => {
          let data = res.data;
          // console.log("data", data);
          if (!data || data === "" || data === "undefined") {
            payload.msg = "Paying in Progress";
            obj._startGetPingStatusForYeahpay(ind, payload);
          } else {
            const order = data;
            if (order.status && order.status === "2") {
              payload.msg = "Successful payment";
              API.callbackPingYeahpayStatus(order).then((res) => {
                obj._startGetPingStatus(0, payload);
              });
            } else if (order.status && order.status === "0") {
              payload.msg = "Paying in progress";
            } else if (order.status && order.status === "6") {
              payload.msg = "Order closed";
            } else if (order.status && order.status === "8") {
              payload.msg = "Payment failure";
            } else if (order.status && order.status === "10") {
              payload.msg = "Refunds pending";
            } else if (order.status && order.status === "11") {
              payload.msg = "Successful refund";
            } else if (order.status && order.status === "12") {
              payload.msg = "Refund failure";
            } else {
              payload.msg = "Payment Unknown Error";
            }
          }
        })
        .catch((err) => {
          // console.log(err);
          // console.log("--Yeahpay Ping Error-");
          obj._startGetPingStatusForYeahpay(ind, payload);
        });
    }, timePoll * 1000);
  }
  _renderCartEntry() {
    const { cartStore, showTabsPage } = this.props;
    if (cartStore.entries.length === 0) {
      if (cartStore.menuStore.layout === 4) {
        return (
          <div style={{ textAlign: "center", paddingTop: "20%" }}>
            <div className="cartIconCls"></div>
            <br />
            <br />
            <p>
              <strong>{cartStore.menuStore.translation.cart_hungry}</strong>
            </p>
            <p>{cartStore.menuStore.translation.coco_empty_cart}</p>
            <Button
              onClick={() => {
                showTabsPage("menu");
              }}
              className="browsebtn"
            >
              {cartStore.menuStore.translation.browse}
            </Button>
          </div>
        );
      } else {
        return (
          <div style={{ textAlign: "center", paddingTop: "20%" }}>
            <FiShoppingCart size={35} />
            <br />
            <br />
            {cartStore.menuStore.translation.cart_empty}
          </div>
        );
      }
    } else {
      return _.map(cartStore.entries, function (entry, ind) {
        return (
          <Fragment key={entry.item.id + ind}>
            <div className="cartHeader" />
            <CartItem entry={entry} cartStore={cartStore} ind={ind} />
          </Fragment>
        );
      });
    }
  }
  _renderConfimPopup() {
    if (
      this.props.cartStore.entries.length > 0 &&
      this.props.cartStore.menuStore.layout !== 4
    ) {
      return (
        <Fragment>
          <div className="withoutLog clearCartBtn">
            <Button
              className="bypassbtn greytext"
              onClick={() => {
                alert(
                  this.props.cartStore.menuStore.translation
                    .clear_pending_title,
                  this.props.cartStore.menuStore.translation.clear_pending_msg,
                  [
                    {
                      text: this.props.cartStore.menuStore.translation.cancel,
                    },
                    {
                      text: this.props.cartStore.menuStore.translation.confirm,
                      onPress: () => {
                        this.props.cartStore.empty();
                        this.props.cartStore.menuStore.sendGoogleAnalytics(
                          "Click",
                          "Reset Order",
                          this.props.cartStore.menuStore.controller,
                          1
                        );
                      },
                    },
                  ]
                );
              }}
            >
              <FaTrashAlt color={"#666"} size={16} className="trashIcon" />
              <span style={{ marginLeft: "5px" }}>
                {
                  this.props.cartStore.menuStore.translation
                    .clear_pending_order_all
                }
              </span>
            </Button>
          </div>
          {this.props.cartStore.menuStore.isKopikingControler() && (
            <div className="fkopi">
              <div className="flinks">
                <a
                  href="/term-conditions.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {this.props.cartStore.menuStore.translation.term_condition}{" "}
                </a>
                <a
                  href="/privacy-policy.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {this.props.cartStore.menuStore.translation.privacy_policy}{" "}
                </a>
                <a
                  href="/return-policy.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {this.props.cartStore.menuStore.translation.return_policy}{" "}
                </a>
                <a href="/faq.html" target="_blank" rel="noopener noreferrer">
                  {this.props.cartStore.menuStore.translation.faq}{" "}
                </a>
              </div>
              <div className="infofooter">
                <div className="pfotter">
                  <h3>Payment Methods</h3>
                  Credit Cards accepted
                  <img
                    src="/theme/img/pgate.jfif"
                    style={{ maxWidth: "200px" }}
                    alt="payment gateway"
                  />
                </div>

                <div className="pfotter">
                  <h3>Contact Info:</h3>
                  <p> Email: kopi.ong@kopi-king.com</p>
                  <p>Contact Number: 84283728</p>
                  <p>
                    Address: Kopi Ong @ MBFC Tower 3: 12 Marina Blvd, #01-04,
                    Singapore 018982
                  </p>
                </div>
              </div>
            </div>
          )}
          <PowerBy />
        </Fragment>
      );
    } else {
      return "";
    }
  }
  _renderCircleProgress = (countdown, total_limit, closeText) => {
    let total_time = total_limit ? total_limit : COUNTDOWN_LIMIT;
    return (
      <div style={{ width: "100%", textAlign: "center" }}>
        <div style={{ position: "absolute", width: "100%" }}>
          {closeText
            ? closeText
            : this.props.cartStore.menuStore.translation.cancel}
        </div>
        <div
          style={{
            width: "35px",
            float: "right",
            paddingRight: 12,
            paddingTop: 4,
            position: "relative",
          }}
        >
          <CircularProgressbar
            percentage={(Math.abs(countdown - total_time) / total_time) * 100}
            strokeWidth={50}
            textForPercentage={null}
            styles={{
              width: 20,
              path: { strokeLinecap: "butt" },
              text: { fill: "#000" },
            }}
          />
        </div>
      </div>
    );
  };

  _callMerchantCreateOrderApi = (param) => {
    //this._setPopupForMerchantStatus();
    let respR = { status: "0" };
    //let totaltimeCnt=20;
    return new Promise((resolve, reject) => {
      if (param === "") {
        // For payment processing, we still need to get orderKey from server
        // This is different from the main checkout flow
        this.props.cartStore
          .prepareOrderSummaryOptimized("")
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            // console.log(err);
            resolve(respR);
          });
      } else {
        //// console.log(param, 'param');
        this.props.cartStore
          .prepareOrderAmount(param)
          .then((resP) => {
            resolve(resP);
          })
          .catch((err) => {
            resolve(respR);
          });
      }
    });
  };
  _callCartStatusCheck = (res) => {
    if (res === 2) {
      this.setState({
        promptContent: "",
        promptTitle: "",
        promptPopup: false,
        promptLoading: false,
      });
      return;
    } else if (
      res.toString().indexOf('"method":"cash"') > 0 ||
      res === "nogateway"
    ) {
      if (this.props.cartStore.menuStore.layout === 4) {
        this.setState(
          {
            payLoad: res,
            promptLoading: true,
            promptPopup: true,
            promptTitle: "",
            promptContent:
              this.props.cartStore.menuStore.translation.cart_processing_order,
          },
          () => {
            this.props.cartStore
              .checkout(this.state.verificationCode, this.state.payLoad)
              .then((res) => {
                this.props.cartStore.tabHandler("order");
                this._callCheckOrderStatus(res);
              })
              .catch((err) => {
                console.log("🔴 Network Error in Cart:", err);
                
                // Check if this is a network error that might have created duplicate orders
                const isNetworkError = err.content && err.content.includes('network') || 
                                     err.title && err.title.includes('network') ||
                                     !err.content; // Empty content often means network error
                
                if (isNetworkError) {
                  console.log('🌐 Network error detected - order might have been created');
                  this.setState({
                    promptTitle: this.props.cartStore.menuStore.translation.network_error_title,
                    promptContent: this.props.cartStore.menuStore.translation.network_error_message,
                    promptLoading: false,
                    closePopup: [
                      {
                        text: this.props.cartStore.menuStore.translation.check_order_status,
                        onPress: () => {
                          clearInterval(countdownTimer);
                          clearTimeout(cancelCheckout);
                          // Check recent orders instead of retrying
                          this._checkRecentOrders();
                        },
                      },
                      {
                        text: this.props.cartStore.menuStore.translation.close,
                        onPress: () => {
                          clearInterval(countdownTimer);
                          clearTimeout(cancelCheckout);
                          this.setState({
                            promptPopup: false,
                            promptContent: "",
                          });
                        },
                      },
                    ],
                  });
                } else {
                  // Regular error - allow retry
                  this.setState({
                    promptTitle: err.title,
                    promptContent: err.content ? err.content : "",
                    promptLoading: false,
                    closePopup: [
                      {
                        text: this.props.cartStore.menuStore.translation
                          .try_again,
                        onPress: () => {
                          clearInterval(countdownTimer);
                          clearTimeout(cancelCheckout);
                          this._callCartStatusCheck(res);
                        },
                      },
                      {
                        text: this.props.cartStore.menuStore.translation.close,
                        onPress: () => {
                          clearInterval(countdownTimer);
                          clearTimeout(cancelCheckout);
                          this.setState({
                            promptPopup: false,
                            promptContent: "",
                          });
                        },
                      },
                    ],
                  });
                }
              });
          }
        );
      } else {
        this.setState({ payLoad: res });
        this._prepareCountdown();
      }
      return;
    } else {
      this.setState({
        promptPopup: true,
        promptLoading: true,
        promptTitle: "",
        promptContent:
          this.props.cartStore.menuStore.translation.cart_processing_order,
        closePopup: [],
      });
      // console.log("res", res);
      if (res !== 1) {
        this._callCheckOrderStatus(res);
      }
    }
  };
  _checkRecentOrders = () => {
    console.log('🔍 Checking recent orders for network error recovery...');
    
    this.setState({
      promptPopup: true,
      promptLoading: true,
      promptTitle: this.props.cartStore.menuStore.translation.checking_order_status,
      promptContent: this.props.cartStore.menuStore.translation.checking_order_status_message,
      closePopup: [],
    });

      // Get current UUID and receipt_id from cart
  const { cartStore } = this.props;
  const uuid = cartStore.CustomOrderId || (this.state.payLoad && this.state.payLoad.uuid);
  const receiptId = this.state.payLoad && this.state.payLoad.receipt_id;
    
    console.log('🔍 Checking with UUID:', uuid, 'Receipt ID:', receiptId);
    
    // Try to get recent orders from server
    // First, try the new endpoint (if implemented)
    const tryGetRecentOrders = () => {
      return API.getRecentOrders(5, 10, uuid, receiptId)
        .then((res) => {
          console.log('📋 API Response from getRecentOrders:', res);
          return res;
        })
        .catch((err) => {
          console.log('❌ getRecentOrders endpoint not available, trying fallback...');
          return null;
        });
    };

    // Fallback: try to get order by UUID if we have one
    const tryGetOrderByUuid = () => {
      if (!uuid) {
        console.log('⚠️ No UUID available for getOrderByUuid');
        return Promise.resolve(null);
      }
      
      console.log('🔍 Trying to get order by UUID:', uuid);
      return API.getOrderByUuid(uuid, receiptId)
        .then((res) => {
          console.log('📋 API Response from getOrderByUuid:', res);
          if (res && res.success && res.order) {
            // Convert single order response to array format for consistency
            return {
              success: true,
              orders: [res.order],
              total: 1,
              message: "Found 1 order"
            };
          }
          return null;
        })
        .catch((err) => {
          console.log('❌ Error getting order by UUID:', err);
          return null;
        });
    };

    // Try both methods
    Promise.all([tryGetRecentOrders(), tryGetOrderByUuid()])
      .then(([recentOrdersRes, orderByUuidRes]) => {
        console.log('📋 Recent Orders Response:', recentOrdersRes);
        console.log('📋 Order by UUID Response:', orderByUuidRes);
        
        // Combine results from both APIs intelligently
        let allOrders = [];
        
        // Add orders from getRecentOrders if available
        if (recentOrdersRes && recentOrdersRes.success && recentOrdersRes.orders) {
          allOrders = allOrders.concat(recentOrdersRes.orders);
        }
        
        // Add order from getOrderByUuid if available (usually more detailed/updated)
        if (orderByUuidRes && orderByUuidRes.success && orderByUuidRes.orders) {
          allOrders = allOrders.concat(orderByUuidRes.orders);
        }
        
        console.log('📋 Combined orders from both APIs:', allOrders);
        
        if (allOrders.length > 0) {
          console.log('✅ Recent orders found:', allOrders);
          
          // Add orders to local storage
          allOrders.forEach(order => {
            cartStore.orderStore.addOrder({
              id: order.id,
              status: order.status,
              cartEntries: order.cartEntries,
              orderNo: order.orderNo,
              timestamp: order.created_at || order.timestamp
            });
          });
          
          this.setState({
            promptPopup: false,
            promptLoading: false,
          });
          
          // Navigate to order page
          cartStore.tabHandler("order");
        } else {
          console.log('📭 No recent orders found');
          this.setState({
            promptTitle: this.props.cartStore.menuStore.translation.no_recent_orders,
            promptContent: this.props.cartStore.menuStore.translation.no_recent_orders_message,
            promptLoading: false,
            closePopup: [
              {
                text: this.props.cartStore.menuStore.translation.try_again,
                onPress: () => {
                  this.setState({
                    promptPopup: false,
                    promptContent: "",
                  });
                  // Allow retry
                  this._callCartStatusCheck(this.state.payLoad);
                },
              },
              {
                text: this.props.cartStore.menuStore.translation.close,
                onPress: () => {
                  this.setState({
                    promptPopup: false,
                    promptContent: "",
                  });
                },
              },
            ],
          });
        }
      })
      .catch((err) => {
        console.log('❌ Error fetching recent orders:', err);
        this.setState({
          promptTitle: this.props.cartStore.menuStore.translation.order_status_unknown,
          promptContent: this.props.cartStore.menuStore.translation.order_status_unknown_message,
          promptLoading: false,
          closePopup: [
            {
              text: this.props.cartStore.menuStore.translation.close,
              onPress: () => {
                this.setState({
                  promptPopup: false,
                  promptContent: "",
                });
              },
            },
          ],
        });
      });
  };

  _callCheckOrderStatus = (res) => {
    // Check if response is duplicated
    if (res && res.isDuplicated) {
      console.log('🔄 DUPLICATED ORDER - Showing message to user');
      
      // If it's duplicated:Unknown and orders were fetched, show additional message
      let content = res.content || this.props.cartStore.menuStore.translation.duplicated_order_message;
      // if (res.shouldFetchOrders) {
      //   if (res.ordersFound) {
      //     const orderCount = res.total || 0;
      //     content += `\n\n${orderCount} recent order(s) have been fetched and updated in your order history.`;
      //   } else {
      //     content += '\n\nNo recent orders found from server.';
      //   }
      // }
      
      this.setState({
        promptPopup: true,
        promptLoading: false,
        promptTitle: res.title || this.props.cartStore.menuStore.translation.error,
        promptContent: content,
        closePopup: [
          {
            text: this.props.cartStore.menuStore.translation.close,
            onPress: () => {
              this.setState({
                promptPopup: false,
                promptContent: "",
              });
            },
          },
        ],
      });
      return;
    }

    // Refresh campaign balances after successful order completion and cart empty
    this.fetchCampaignsAndUpdate();

    let timeInt = 30;
    this.setState({ checked: false });

    const { cartStore } = this.props;

    cartStore.remarks = "";
    cartStore.takeAway = false;

    // window.gtag('event','Checkout', {  'event_category': 'order',  'event_label': cartStore.menuStore.controller,  'value': cartStore.total*100});

    let orders = cartStore.orderStore.lists;
    let lastOrIndex = orders.length - 1;
    let lastOrder = orders[lastOrIndex];
    // let timerId;
    let timerOut;

    timerOut = setTimeout(() => {
      clearInterval(countdownTimer);
      clearTimeout(timerOut);
      this.setState({ promptPopup: false });
      //if (orders[lastOrIndex].status === null) {
      var ele = document.querySelectorAll(".order_item");
      //ele[0].click();
      var evt = document.createEvent("Event");
      evt.initEvent("click", true, true);

      let eleN = ele[0];
      eleN.dispatchEvent(evt);
      eleN.click();

      //}
    }, timeInt * 1000);

    this.setState({
      timeCountdown: timeInt,
      promptTitle: cartStore.menuStore.translation.order_waiting,
      //promptContent: res.content,
      promptContent: cartStore.menuStore.translation.checkout_message,
      promptLoading: cartStore.menuStore.layout === 4 ? true : false,
      //promptPopup: false
    });

    let start = 1;
    countdownTimer = setInterval(() => {
      orders = cartStore.orderStore.lists;
      lastOrIndex = orders.length - 1;
      lastOrder = orders[lastOrIndex];

      if (start > 0 && orders[lastOrIndex].status < 2) {
        start = 0;
        cartStore.orderStore.checkOrder(lastOrder).then((resApi) => {
          orders = cartStore.orderStore.lists;
          lastOrIndex = orders.length - 1;
          lastOrder = orders[lastOrIndex];
          if (orders[lastOrIndex].status > 1) {
            this.setState({ promptPopup: false });
            //clearInterval(timerId);
            clearInterval(countdownTimer);
            clearTimeout(timerOut);
            var ele = document.querySelectorAll(".order_item");
            // ele[0].click();

            var evt = document.createEvent("Event");
            evt.initEvent("click", true, true);

            //let ele = document.querySelector("#checkoutButton");
            let eleN = ele[0];
            eleN.dispatchEvent(evt);
            eleN.click();
          } else {
            start = 1;
          }
        });
      }
      //  start = start + 1;

      if (cartStore.menuStore.layout !== 4) {
        this.setState(
          {
            // promptPopup: true,
            timeCountdown: this.state.timeCountdown - 1,
          },
          () => {
            this.setState({
              closePopup: [
                {
                  //text: cartStore.menuStore.translation.cart_check_order,
                  text: this._renderCircleProgress(
                    this.state.timeCountdown,
                    timeInt,
                    cartStore.menuStore.translation.check_later
                  ),
                  onPress: () => {
                    //clearInterval(timerId);
                    clearTimeout(countdownTimer);
                    clearTimeout(timerOut);
                    this.setState({
                      promptPopup: false,
                    });
                  },
                },
              ],
            });
          }
        );
      }
    }, 1000);
  };
  _prepareCountdown = () => {
    const { cartStore } = this.props;

    this.setState(
      {
        timeCountdown: COUNTDOWN_LIMIT,
      },
      () => {
        this.setState({
          promptPopup: true,
          promptTitle: "",
          promptContent: cartStore.menuStore.translation.cart_preparing_order,
          promptLoading: false,
          closePopup: this._defaultClose(
            this._renderCircleProgress(this.state.timeCountdown)
          ),
        });
      }
    );
    countdownTimer = setInterval(() => {
      this.setState(
        {
          timeCountdown: this.state.timeCountdown - 1,
        },
        () => {
          this.setState({
            closePopup: this._defaultClose(
              this._renderCircleProgress(this.state.timeCountdown)
            ),
          });
        }
      );
    }, 1000);

    cancelCheckout = setTimeout(() => {
      clearInterval(countdownTimer);
      // Handle failed checkout
      countdownTimer = setTimeout(() => {
        this.setState({
          promptTitle: cartStore.menuStore.translation.error,
          promptContent: cartStore.menuStore.translation.error_network,
          promptLoading: false,
          closePopup: this._defaultClose(),
        });
      }, 20000);

      this.setState({
        promptLoading: true,
        promptTitle: cartStore.menuStore.translation.cart_processing_order,
        closePopup: [],
      });

      cartStore
        .checkout(this.state.verificationCode, this.state.payLoad)
        .then((res) => {
          clearTimeout(cancelCheckout);
          clearTimeout(countdownTimer);
          cartStore.tabHandler("order");
          this._callCheckOrderStatus(res);
        })
        .catch((err) => {
          // console.log("Error Cart :", err);
          clearTimeout(cancelCheckout);
          clearTimeout(countdownTimer);
          this.setState({
            promptTitle: err.title,
            promptContent: err.content ? err.content : "",
            promptLoading: false,
            closePopup: [
              {
                text: this.props.cartStore.menuStore.translation.try_again,
                onPress: () => {
                  this._callCartStatusCheck(this.state.payLoad);
                },
              },
              {
                text: this.props.cartStore.menuStore.translation.close,
                onPress: () => {
                  this.setState({
                    promptPopup: false,
                    promptContent: "",
                  });
                },
              },
            ],
          });
        });
    }, COUNTDOWN_LIMIT * 1000);
  };

  _promptVerification = () => {
    prompt(
      this.props.cartStore.menuStore.translation.verification,
      this.props.cartStore.menuStore.translation.verification_message,
      [
        {
          text: this.props.cartStore.menuStore.translation.cancel,
          onPress: () =>
            new Promise((resolve) => {
              resolve(null);
            }),
        },
        {
          text: this.props.cartStore.menuStore.translation.confirm,
          onPress: (value) => {
            this._checkoutFlow(value);
          },
        },
      ]
    );
  };

  _checkoutFlow = (value) => {
    if (
      this.props.cartStore.menuStore.checkVerificationCode(
        value.replace(/ /g, "")
      )
    ) {
      this.setState({
        verificationCode: value,
      });

      this._prepareCountdown();
    } else {
      alert(
        this.props.cartStore.menuStore.translation.verification_invalid,
        null,
        [
          {
            text: this.props.cartStore.menuStore.translation.close,
            onPress: () => {},
          },
        ]
      );
    }
  };

  _clickCheckout = (e) => {
    e.click();
  };
  _handleCheckoutAction = (erroMsg) => {
    const { cartStore } = this.props;
    const isStoreOpen = cartStore.checkOperatingHour();
    if (isStoreOpen !== true && cartStore.menuStore.layout !== 4) {
      this.setState({
        promptTitle: isStoreOpen.title,
        promptContent: isStoreOpen.content,
        promptLoading: false,
        promptPopup: true,
        closePopup: this._defaultClose(),
      });
      return false;
    }
    cartStore.checkCartsStatus();
    if (erroMsg !== "" || isStoreOpen !== true) {
      let msg =
        isStoreOpen !== true
          ? isStoreOpen.content
          : this.props.cartStore.menuStore.translation.not_available_msg;
      if (cartStore.menuStore.layout === 4) {
        alert(
          <div className="cartItem"></div>,
          <div
            dangerouslySetInnerHTML={{
              __html: this.props.cartStore.menuStore.htmlDecode(msg),
            }}
          />,
          [
            {
              text: this.props.cartStore.menuStore.translation.close,
            },
          ]
        );
      }
      return false;
    } else if (cartStore.menuStore.areaLimit > 0) {
      localStorage.removeItem("is_opened_post_question");
    }
    if (cartStore.menuStore.socialCheckout === true) {
      if (
        !("id" in cartStore.menuStore.social) &&
        !("eberId" in cartStore.menuStore.social)
      ) {
        if (cartStore.menuStore.isBWCMethod()) {
          let msg = cartStore.menuStore.translation.invalid_bwc_membership;
          alert(
            <div className="cartItem"></div>,
            <div
              dangerouslySetInnerHTML={{
                __html: cartStore.menuStore.htmlDecode(msg),
              }}
            />,
            [
              {
                text: cartStore.menuStore.translation.close,
              },
            ]
          );
        } else {
          // Only show login modal if membership account is enabled
          const enableMembershipAccount = localStorage.getItem(
            `${cartStore.menuStore.controller}_enable_membership_account`
          ) === 'true';
          if (enableMembershipAccount) {
            cartStore.menuStore.isLoginModalVisible = true;
            console.log('Showing login modal (membership enabled + socialCheckout + no social data)');
          } else {
            console.log('Not showing login modal (membership disabled)');
          }
        }
        return;
      }
    }
    cartStore.isTagExpired();
    if (cartStore.menuStore.checkPostFields()) {
      return false;
    }
    if (cartStore.isTagExpired()) {
      localStorage.removeItem(`${this.controller}_noRedirect`);
      this.setState({
        promptPopup: true,
        promptTitle: "",
        promptLoading: false,
        promptContent: cartStore.menuStore.translation.scan_message, //"To place order, SCAN the QR Code again.",
        closePopup: [
          {
            text: cartStore.menuStore.translation.close,
            onPress: () => {
              this.setState({
                promptPopup: false,
              });
            },
          },
        ],
      });
    } else {
      cartStore.resetEntries();
      if (
        cartStore.menuStore.verificationCode === null ||
        !cartStore.isCodeExpired()
      ) {
        let tagObj = cartStore.menuStore.checkTagAction(); //'payment', '0'
        let paymentAction = "";
        if (tagObj.payment) {
          paymentAction = tagObj.payment;
        }
        // Debug payment logic
        console.log('🔍 [Cart] layout:', cartStore.menuStore.layout);
        console.log('🔍 [Cart] paymentAction:', paymentAction);
        console.log('🔍 [Cart] paymentGateways.length:', cartStore.menuStore.paymentGateways.length);
        console.log('🔍 [Cart] paymentGateways:', cartStore.menuStore.paymentGateways);
        
        if (
          paymentAction === "0" ||
          cartStore.menuStore.paymentGateways.length === 0 ||
          (paymentAction === "2" && Math.ceil(cartStore.total) === 0)
        ) {
          console.log('🔍 [Cart] Opening nogateway');
          //this._prepareCountdown();
          this.callPymanetOptions.openSinglePaymentGateway("nogateway");
        } else if (cartStore.menuStore.paymentGateways.length === 1) {
          console.log('🔍 [Cart] Opening single gateway:', cartStore.menuStore.paymentGateways[0]);
          this.callPymanetOptions.openSinglePaymentGateway(
            cartStore.menuStore.paymentGateways[0]
          );
        } else if (cartStore.menuStore.paymentGateways.length > 1) {
          console.log('🔍 [Cart] Showing payment option modal');
          cartStore.menuStore.showPaymentOption = true;
        }
        localStorage.removeItem("is_opened_post_question");
      } else {
        cartStore.removeCachedCode();
        this._promptVerification();
      }
    }
  };
  _renderCheckout() {
    const { cartStore } = this.props;
    let isDisplayPrice = cartStore.checkTotoitoastOutlet();
    let erroMsg = this._getErrorMsg();
    let iconbtn = <FaCheckCircle color="green" />;

    if (erroMsg !== "") {
      iconbtn = <FaTimesCircle color="red" />;
    }
    if (cartStore.menuStore.layout === 4) {
      iconbtn = "";
    }
    const totalText = `${cartStore.menuStore.currencySymbol} ${cartStore.total}`;

    return (
      <Button
        style={{ cursor: "pointer" }}
        // href="#"
        id="checkoutButton"
        onClick={() => {
          //    // console.log(cartStore.menuStore.areaLimit);
          let checkValidRedeem = cartStore.checkValidRedeemAmount();
          if (isDisplayPrice === "error") {
            this.setState({
              promptTitle: this.menuStore.translation.invalid_outlet_title,
              promptContent: this.menuStore.translation.invalid_outlet_message,
              promptLoading: false,
              promptPopup: true,
              closePopup: this._defaultClose(),
            });
            return false;
          } else if (checkValidRedeem === "error") {
            let msg = cartStore.menuStore.translation.less_redeem_amount;
            alert(
              <div className="cartItem"></div>,
              <div
                dangerouslySetInnerHTML={{
                  __html: cartStore.menuStore.htmlDecode(msg),
                }}
              />,
              [
                {
                  text: cartStore.menuStore.translation.change_voucher,
                  onPress: () => {
                    cartStore.menuStore.openRewardListModal = true;
                  },
                },
                {
                  text: cartStore.menuStore.translation.add_new_items,
                  onPress: () => {
                    this.props.showTabsPage("menu");
                  },
                },
              ]
            );
          } else {
            this._handleCheckoutAction(erroMsg);
          }
        }}
        disabled={erroMsg !== "" && cartStore.menuStore.layout !== 4}
      >
        {iconbtn}&nbsp;
        {cartStore.menuStore.translation.confirm}{" "}
        {parseFloat(cartStore.total) === 0 ||
        isDisplayPrice === "error" ||
        isDisplayPrice === false
          ? ""
          : totalText}
      </Button>
    );
  }

  _defaultClose = (closeText) => {
    return [
      {
        text: closeText
          ? closeText
          : this.props.cartStore.menuStore.translation.close,
        onPress: () => {
          clearInterval(countdownTimer);
          clearTimeout(cancelCheckout);
          //localStorage.removeItem("is_opened_post_question");
          this.setState({
            promptPopup: false,
            //htmlMsg:false,
            promptContent: "",
          });
        },
      },
    ];
  };

  _popupContent = () => {
    //// console.log(999,this.state.promptContent);
    return (
      <div>
        {Array.isArray(this.state.promptContent) ? (
          <div>
            <div> {this.state.promptContent[0]} </div>
            <div> {this.state.promptContent[1]} </div>
          </div>
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: this.props.cartStore.menuStore.htmlDecode(
                this.state.promptContent
              ),
            }}
          />
        )}
      </div>
    );
  };

  _renderPromptPopup = () => {
    return (
      <PromptPopup
        visibility={this.state.promptPopup}
        title={this.state.promptTitle}
        closePopup={this.state.closePopup}
        content={this._popupContent()}
        isLoading={this.state.promptLoading}
        // htmlMsg={this.state.htmlMsg}
        cartStore={this.props.cartStore}
      />
    );
  };
  _getErrorMsg = () => {
    let tagObj = this.props.cartStore.menuStore.checkTagAction();
    let qty = this.props.cartStore.size;
    //// console.log(qty,'qty');
    let freeQty = this.props.cartStore.freeQty;
    let erroMsg = "";
    if (this.props.cartStore.menuStore.notAvailable.length > 0) {
      erroMsg = this.props.cartStore.menuStore.translation.not_available_msg;
    } else if (
      tagObj.min_order &&
      tagObj.min_order > -1 &&
      this.props.cartStore.total < tagObj.min_order
    ) {
      erroMsg = tagObj.min_order_message;
    } else if (
      tagObj.max_order &&
      tagObj.max_order > -1 &&
      this.props.cartStore.total > tagObj.max_order
    ) {
      erroMsg = tagObj.max_order_message;
    } else if (tagObj.min_qty && tagObj.min_qty > -1 && qty < tagObj.min_qty) {
      erroMsg = tagObj.min_qty_message;
    } else if (
      tagObj.max_free_qty &&
      tagObj.max_free_qty > -1 &&
      freeQty > tagObj.max_free_qty
    ) {
      erroMsg = tagObj.max_free_qty_message;
    } else if (tagObj.max_qty && tagObj.max_qty > -1 && qty > tagObj.max_qty) {
      erroMsg = tagObj.max_qty_message;
    }
    return erroMsg;
  };

  render() {
    let erroMsg = this._getErrorMsg();
    let title = this.props.cartStore.menuStore.translation.clear_pending_title;
    let alertMsg = this.props.cartStore.menuStore.translation.clear_pending_msg;
    let yesButton = this.props.cartStore.menuStore.translation.confirm;
    if (this.props.cartStore.menuStore.layout === 4) {
      title = <Icon type="exclamation-circle-o" style={{ fontSize: "50px" }} />;
      yesButton = this.props.cartStore.menuStore.translation.yes;
      alertMsg = (
        <div
          dangerouslySetInnerHTML={{
            __html: this.props.cartStore.menuStore.htmlDecode(
              this.props.cartStore.menuStore.translation.clear_cart_message
            ),
          }}
        />
      );
    }
    let input_promocode = localStorage.getItem(`input_promocode`);
    if (!input_promocode) {
      input_promocode = "";
    }
    let rewardName = this.props.cartStore.appliedRewardName();
    let rewardDetails = this.props.cartStore.appliedRewardDetails || {};

    return (
      <Fragment>
        <div>
          {this.props.cartStore.menuStore.layout !== 4 && (
            <div
              className={
                this.props.cartStore.size > 0 && erroMsg !== ""
                  ? "notavialableCls"
                  : "hideErrorMessage"
              }
            >
              <div>{erroMsg}</div>
            </div>
          )}
          <div
            className={
              erroMsg !== ""
                ? "checkoutBtn checkoutBtnGrey"
                : "checkoutBtn confirmCheckoutBtn"
            }
          >
            {this.props.cartStore.size > 0 && this._renderCheckout()}
          </div>
          <div className="viewPortCart">
            {this.props.cartStore.entries.length > 0 &&
            this.props.cartStore.menuStore.takeaway > 0 &&
            this.props.cartStore.menuStore.layout !== 4 ? (
              <Fragment key="takeaway">
                <div className="cartHeader" />
                <div className="takeAway">
                  <List.Item
                    extra={
                      <Switch
                        checked={this.state.checked}
                        color="#108ee9"
                        onChange={() => {
                          this.setState({
                            checked: !this.state.checked,
                          });
                          this.props.cartStore.takeAway =
                            !this.props.cartStore.takeAway;
                        }}
                      />
                    }
                  >
                    <FaPaperclip color={"#666"} />
                    <span>
                      {this.props.cartStore.menuStore.translation.take_away}
                    </span>
                  </List.Item>
                </div>
              </Fragment>
            ) : (
              ""
            )}
            {this.props.cartStore.entries.length > 0 &&
            this.props.cartStore.menuStore.isRemarksVisible &&
            this.props.cartStore.menuStore.layout !== 4 ? (
              <Fragment key="remarks">
                <div className="cartHeader" />
                <div className="takeAway">
                  <InputItem
                    style={{ width: "100%" }}
                    placeholder={
                      this.props.cartStore.menuStore.translation.remarks
                    }
                    onChange={(value) => {
                      this.props.cartStore.remarks = value;
                    }}
                    clear
                  >
                    <FaPaperclip color={"#666"} />
                  </InputItem>
                </div>
              </Fragment>
            ) : (
              ""
            )}

            <div className="cartScreen">
              {this._renderCartEntry()}
              {this.props.cartStore.entries.length > 0 &&
              this.props.cartStore.menuStore.layout === 4 ? (
                <Fragment>
                  <div className="cartlinks">
                    <span
                      className="clearCart"
                      onClick={() => {
                        alert(title, alertMsg, [
                          {
                            text: this.props.cartStore.menuStore.translation
                              .cancel,
                          },
                          {
                            text: yesButton,
                            onPress: () => {
                              this.props.cartStore.empty();
                              this.props.cartStore.menuStore.sendGoogleAnalytics(
                                "Click",
                                "Reset Order",
                                this.props.cartStore.menuStore.controller,
                                1
                              );
                            },
                          },
                        ]);
                      }}
                    >
                      {this.props.cartStore.menuStore.translation.clear_cart}
                    </span>
                    <span
                      className="addcartitems"
                      onClick={() => {
                        this.props.showTabsPage("menu");
                      }}
                    >
                      <FaPlus />
                      {this.props.cartStore.menuStore.translation.add_more_item}
                    </span>
                  </div>
                  {(() => {
                    const socialData =
                      (this.props.cartStore.menuStore &&
                        this.props.cartStore.menuStore.social) ||
                      {};
                    const appliedRewardsCount = (Array.from(
                      (socialData && socialData.appliedRewards) || []
                    ).length || 0) + (socialData && socialData.redeem ? 1 : 0) > 0
                      ? Math.min(
                          2,
                          Array.from((socialData && socialData.appliedRewards) || [])
                            .length + (socialData && socialData.redeem ? 1 : 0)
                        )
                      : 0;
                    if (appliedRewardsCount > 0) {
                      const breakdown = this.props.cartStore.appliedRewardsBreakdown || [];
                      return (
                        <>
                          {breakdown.map((b, idx) => (
                            <div className="rewardVoucherInfo" key={`rw-${idx}`}>
                              <span className="cartRewardName">{b.type === 'cashback' || b.type === 'stored-value' ? 'Rebate' : (b.type === 'voucher' ? 'Discount Voucher' : (b.name || 'Reward'))}</span>
                              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                <div
                                  className="cartRewardIconText"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    this.setState({ promoPopup: true });
                                    this.fetchCampaignsAndUpdate();
                                  }}
                                >
                                  {b.amount > 0 && (
                                    <> - ${parseFloat(b.amount || 0).toFixed(2)} discounted</>
                                  )}
                                </div>
                                {appliedRewardsCount < 2 && (
                                  <Button
                                    size="small"
                                    className="addpromolink"
                                    onClick={() => {
                                      this.setState({ promoPopup: true });
                                      this.fetchCampaignsAndUpdate();
                                    }}
                                  >
                                    Add Reward
                                  </Button>
                                )}
                              </div>
                            </div>
                          ))}
                        </>
                      );
                    }
                    return !rewardName || rewardName === "" ? (
                    <div className="voucherInfo">
                      {" "}
                      <Button
                        onClick={() => {
                          this.setState({ promoPopup: true });
                          // Recalculate campaign balances when opening promo popup
                          this.fetchCampaignsAndUpdate();
                        }}
                        className="addpromolink"
                      >
                        <span>Promo Code </span>
                      </Button>
                      {input_promocode && input_promocode !== "" && (
                        <span className="promodelete">
                          ({input_promocode})
                          <div
                            className="cartItemDelete"
                            onClick={() => {
                              localStorage.removeItem("input_promocode");
                              this.setState({ promocode: "" });
                            }}
                          >
                            <FaTrashAlt color={"#666"} size={16} />
                          </div>
                        </span>
                      )}
                    </div>
                  ) : (
                    <div className="rewardVoucherInfo">
                      <span />
                      <div
                        className="cartRewardIconText"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.setState({ promoPopup: true });
                          // Recalculate campaign balances when opening promo popup
                          this.fetchCampaignsAndUpdate();
                        }}
                      >
                        Add Rewards
                      </div>
                    </div>
                  );
                  })()}
                  <hr className="cart-links-divider" />
                  <div className="cart-links">
                    <div className="cart-link-item">
                      <span className="cart-link-label">Sub Total</span>
                      <span className="cart-link-value">
                        $
                        {parseFloat(
                          this.props.cartStore.sub_total || 0
                        ).toFixed(2)}
                      </span>
                    </div>
                    {rewardDetails.serviceChargeName &&
                      parseFloat(rewardDetails.serviceCharge) > 0 && (
                        <div className="cart-link-item">
                          <span className="cart-link-label">
                            {rewardDetails.serviceChargeName}
                            <span className="cart-link-percent">
                              {" "}
                              ({rewardDetails.serviceChargeRate})
                            </span>
                          </span>
                          <span className="cart-link-value">
                            ${rewardDetails.serviceCharge}
                          </span>
                        </div>
                      )}
                    {rewardDetails.gstName &&
                      parseFloat(rewardDetails.gst) > 0 && (
                        <div className="cart-link-item">
                          <span className="cart-link-label">
                            {rewardDetails.gstName}
                            <span className="cart-link-percent">
                              {" "}
                              ({rewardDetails.gstRate})
                            </span>
                          </span>
                          <span className="cart-link-value">
                            ${rewardDetails.gst}
                          </span>
                        </div>
                      )}
                    {rewardDetails.sstName &&
                      parseFloat(rewardDetails.sst) > 0 && (
                        <div className="cart-link-item">
                          <span className="cart-link-label">
                            {rewardDetails.sstName}
                            <span className="cart-link-percent">
                              {" "}
                              ({rewardDetails.sstRate})
                            </span>
                          </span>
                          <span className="cart-link-value">
                            ${rewardDetails.sst}
                          </span>
                        </div>
                      )}
                    {(() => {
                      // Calculate total membership savings from price differences
                      const totalMembershipSavings =
                        this.props.cartStore.entries.reduce((total, entry) => {
                          const item = entry.item;
                            
                          // Check if membership pricing should be used
                          const tokenExpiry = localStorage.getItem(
                            `${this.props.cartStore.menuStore.controller}_advocado_token_expiry`
                          );
                          const now = new Date().getTime();
                          const useMembership = tokenExpiry && parseInt(tokenExpiry) > now;
                          
                          if (!useMembership) return total;

                          let entrySavings = 0;

                          // Calculate main item savings
                          const baseStandardPrice = parseFloat(item.price) || 0;
                          const baseMembershipPrice = (item.membershipPrice && item.membershipPrice.price) 
                            ? parseFloat(item.membershipPrice.price) 
                            : baseStandardPrice;

                          const mainItemSavings = (baseStandardPrice - baseMembershipPrice) * entry.addons.length;
                          entrySavings += mainItemSavings;

                          // Calculate addon savings using the same logic as CartItem
                          if (entry.addons && entry.addons.length > 0) {
                            let addonSavings = 0;
                            const firstAddonList = entry.addons[0];
                            
                            if (firstAddonList) {
                              const keys = Object.keys(firstAddonList);
                              
                              for (let i = 0; i < keys.length; i++) {
                                const category = keys[i];
                                
                                if (category !== "undefined") {
                                  for (let x = 0; x < firstAddonList[category].length; x++) {
                                    const addon = firstAddonList[category][x];
                                    
                                    if (addon.quantity === 0) continue;
                                    
                                    const addonPrice = parseFloat(addon.price) || 0;
                                    let membershipAddonPrice = addonPrice;
                                    
                                    // Check for stored membership pricing
                                    if (addon.hasMembershipPricing && addon.membershipPrice !== undefined) {
                                      membershipAddonPrice = parseFloat(addon.membershipPrice) || addonPrice;
                                    } else {
                                      // Fallback: Check for duplicate pattern (standard vs membership)
                                      const sameNameAddons = firstAddonList[category].filter(a => a.name === addon.name && a.quantity > 0);
                                      
                                      if (sameNameAddons.length === 2) {
                                        const prices = sameNameAddons.map(a => parseFloat(a.price)).sort((a, b) => b - a);
                                        const standardPrice = prices[0];
                                        const membershipPrice = prices[1];
                                        
                                        if (parseFloat(addon.price) === standardPrice) {
                                          membershipAddonPrice = membershipPrice;
                                        }
                                      }
                                    }
                                    
                                    const addonSavingAmount = (addonPrice - membershipAddonPrice) * addon.quantity;
                                    addonSavings += addonSavingAmount;
                                  }
                                }
                              }
                              
                              // Multiply by number of addon groups
                              addonSavings = addonSavings * entry.addons.length;
                            }
                            
                            entrySavings += addonSavings;
                          }

                          return total + entrySavings;
                        }, 0);

                      let rewardDetails =
                        this.props.cartStore.appliedRewardDetails || {};
                      const breakdown =
                        this.props.cartStore.appliedRewardsBreakdown || [];
                      const rewardLines = breakdown.filter(
                        (b) => parseFloat(b.amount || 0) > 0
                      );
                      const hasRewardSavings = rewardLines.length > 0;
                      const hasMembershipSavings = totalMembershipSavings > 0;

                      // Check if social provider is advocado
                      const social =
                        this.props.cartStore.menuStore.social || {};
                      const isAdvocadoProvider =
                        social && social.provider === "advocado";

                      if (!isAdvocadoProvider) return null;
                      if (!hasRewardSavings && !hasMembershipSavings)
                        return null;

                      return (
                        <div className="membership-savings">
                          <div className="cart-link-item">
                            <span className="cart-link-label">
                              Membership Savings
                            </span>
                          </div>
                          {hasRewardSavings &&
                            rewardLines.map((b, idx) => (
                              <div
                                className="cart-link-item membership-savings-section"
                                key={`ms-${idx}`}
                              >
                                <span className="cart-link-label">
                                  •{' '}
                                  {b.type === 'cashback' || b.type === 'stored-value'
                                    ? 'Rebate'
                                    : b.type === 'voucher'
                                    ? 'Discount Voucher'
                                    : b.name || 'Reward'}
                                </span>
                                <span className="cart-link-value">
                                  -{this.props.cartStore.menuStore.currencySymbol}
                                  {parseFloat(b.amount || 0).toFixed(2)}
                                </span>
                              </div>
                            ))}
                          {hasMembershipSavings && (
                            <div className="cart-link-item membership-savings-section">
                              <span className="cart-link-label">
                                • Member Price
                              </span>
                              <span className="cart-link-value">
                                -{this.props.cartStore.menuStore.currencySymbol}
                                {totalMembershipSavings.toFixed(2)}
                              </span>
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                  <hr className="cart-links-divider" />
                  <div className="cart-total-item">
                    <span className="cart-total-label">Total Payment</span>
                    <span className="cart-total-value">
                      ${this.props.cartStore.total}
                    </span>
                  </div>
                  <Recomendations
                    page="cart"
                    length={this.props.cartStore.entries.length}
                  />

                  <PowerBy />
                </Fragment>
              ) : (
                ""
              )}
            </div>
            {this._renderConfimPopup()}
            {this.props.cartStore.entries.length === 0 ? (
              <CheckBill cartStore={this.props.cartStore} />
            ) : (
              ""
            )}
          </div>

          <div>{this._renderPromptPopup()}</div>

          <PostQuestions
            showModal={
              this.props.cartStore.menuStore.actionModalVisisble === "post"
            }
            //onMounted={postQA => this.checkPostQAy(postQA)}
            //  showErrorMessage={this.showErrorMessage}
            questionFileds={this.props.cartStore.menuStore.postQuestionFileds}
            action_type="post"
            action_opend_key="is_opened_post_question"
          />
          <PaymentOption
            visible={this.props.cartStore.menuStore.showPaymentOption}
            close={() => {
              //this.setState({ showPaymentOption: false });
            }}
            _callPaypalPaymentStatus={this._callPaypalPaymentStatus}
            _callCartStatusCheck={this._callCartStatusCheck}
            _callMerchantCreateOrderApi={this._callMerchantCreateOrderApi}
            onMounted={(openSinglePaymentGateway) =>
              this.checkSinglePaymentGateway(openSinglePaymentGateway)
            }
            total={`${this.props.cartStore.total}`}
          />
        </div>
        <Modal
          visible={this.state.promoPopup}
          transparent
          maskClosable
          animationType="slide-up"
          closable={false}
          className="campaignModal"
          title="Select Campaign"
          footer={[
            {
              text: "Cancel",
              onPress: () => {
                // Clear all campaign/redeem selections from local state…
                this.setState({
                  selectedCampaign: "",
                  selectedRedeem: "",
                  rebateAmount: "",
                  promoPopup: false,
                });
                // …and also clear any applied reward from the cart store.
                this.props.cartStore.menuStore.social.redeem = null;
              },
            },
            {
              text: "Apply",
              onPress: () => {
                const { selectedCampaign, selectedRedeem, rebateAmount } =
                  this.state;

                if (selectedCampaign) {
                  // Check if this is a rebate/cashback campaign with custom amount
                  const selectedCampaignData = this.state.campaignBalances.find(
                    (c) => c.id === selectedCampaign
                  );
                  if (
                    (selectedCampaignData.type === "cashback" ||
                      selectedCampaignData.type === "stored-value") &&
                    rebateAmount
                  ) {
                    // Validate rebate amount
                    const numAmount = parseFloat(rebateAmount);
                    const maxAmount = parseFloat(selectedCampaignData.balance);

                    if (numAmount <= 0) {
                      Toast.fail("Please enter a valid amount greater than 0");
                      return;
                    }

                    if (numAmount > maxAmount) {
                      Toast.fail(
                        `Amount cannot exceed $${maxAmount.toFixed(2)}`
                      );
                      return;
                    }

                    // Apply campaign with custom rebate amount
                    this.applyCampaignWithRebateAmount(
                      selectedCampaign,
                      numAmount
                    );
                  } else if (selectedRedeem) {
                    this.applyCampaign(selectedCampaign, selectedRedeem);
                  } else {
                    this.applyCampaign(selectedCampaign);
                  }
                  rewardName = this.props.cartStore.appliedRewardName();
                  rewardDetails =
                    this.props.cartStore.appliedRewardDetails || {};
                } else {
                  alert("Please select a campaign or redeem option to apply.");
                }

                this.setState({ promoPopup: false }); // Close the popup
              },
            },
          ]}
        >
          <div className="campaignList">
            {this.state.campaignBalances &&
            this.state.campaignBalances.length > 0 ? (
              this.state.campaignBalances.map((campaign) => {
                const balanceLabel =
                  campaign.type === "loyalty"
                    ? `Points: ${campaign.balance}`
                    : campaign.type === "stamps"
                    ? `Stamps: ${campaign.balance}`
                    : campaign.type === "stored-value"
                    ? `Value: $${campaign.balance}`
                    : campaign.type === "cashback"
                    ? `Amount: $${campaign.balance}`
                    : campaign.type === "voucher"
                    ? `Vouchers: ${campaign.balance}`
                    : "Unknown balance type";

                // Inside your map() function, first define:
                const isSelected = this.state.selectedCampaign === campaign.id;
                const currentRedeem = isSelected
                  ? this.state.selectedRedeem
                  : "";
                return (
                  <div
                    onClick={() => {
                      // Reset redeem only if campaign.redeem doesn't exist or is empty.
                      const shouldResetRedeem =
                        !campaign.redeem || campaign.redeem.length === 0;
                      this.setState({
                        selectedCampaign: campaign.id,
                        selectedRedeem: shouldResetRedeem
                          ? ""
                          : this.state.selectedRedeem,
                      });
                    }}
                    key={campaign.id}
                    className={`campaignItem ${
                      this.state.selectedCampaign === campaign.id
                        ? "selected"
                        : ""
                    }`}
                  >
                    <h4>{campaign.name}</h4>
                    <p>{balanceLabel}</p>

                    {/* Input field for rebate/cashback amount */}
                    {(campaign.type === "cashback" ||
                      campaign.type === "stored-value") && (
                      <div className="rebateAmountInput">
                        <label
                          htmlFor={`rebate-amount-${campaign.id}`}
                          className="rebateLabel"
                        >
                          Amount to use:
                        </label>
                        <div className="rebateInputContainer">
                          <span className="currencySymbol">$</span>
                          <input
                            id={`rebate-amount-${campaign.id}`}
                            type="number"
                            className="rebateInput"
                            placeholder="0.00"
                            min="0"
                            max={parseFloat(campaign.balance) || 0}
                            step="0.01"
                            value={
                              this.state.selectedCampaign === campaign.id
                                ? this.state.rebateAmount
                                : ""
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              const maxAmount =
                                parseFloat(campaign.balance) || 0;
                              const numValue = parseFloat(value) || 0;

                              // Validate input
                              if (numValue > maxAmount) {
                                Toast.fail(
                                  `Amount cannot exceed $${maxAmount.toFixed(
                                    2
                                  )}`
                                );
                                return;
                              }

                              this.setState({
                                selectedCampaign: campaign.id,
                                rebateAmount: value,
                                selectedRedeem: "", // Reset redeem selection for rebate
                              });
                            }}
                            onClick={(e) => {
                              // Prevent the campaign item click when clicking on input
                              e.stopPropagation();
                            }}
                          />
                          <span className="maxAmount">
                            (Max: $
                            {parseFloat(campaign.balance || 0).toFixed(2)})
                          </span>
                        </div>
                      </div>
                    )}

                    {campaign.redeem && campaign.redeem.length > 0 && (
                      <div className="redeemDropdown">
                        <label
                          htmlFor={`redeem-select-${campaign.id}`}
                          className="redeemLabel"
                        >
                          Redeem Options:
                        </label>

                        <select
                          id={`redeem-select-${campaign.id}`}
                          className="redeemSelect"
                          value={currentRedeem || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            const redeemOption = campaign.redeem.find(
                              (r) => r.id === selectedValue
                            );
                            this.setState({
                              selectedCampaign: campaign.id,
                              selectedRedeem: redeemOption
                                ? redeemOption.id
                                : "",
                            });
                          }}
                        >
                          <option value="">
                            {isSelected && currentRedeem
                              ? "Change your selection"
                              : "Select an option"}
                          </option>
                          {campaign.redeem.map((redeem, redeemIndex) => {
                            const optionLabel =
                              redeem.type === "dollarValue"
                                ? `$${redeem.value}`
                                : `${redeem.value}%`;
                            return (
                              <option key={redeem.id} value={redeem.id}>
                                {redeem.description}: {optionLabel}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <p>No campaigns available.</p>
            )}
          </div>
        </Modal>
      </Fragment>
    );
  }
}

const CartItem = observer(({ entry, cartStore, ind }) => {
  let item = entry.item;
  let isDisplayPrice = cartStore.menuStore.checkPriceDisplay(item);
  let extratag = (
    <span
      className="qtytextfield"
      onClick={() => {
        cartStore.menuStore.itemModal.showUpdateModal(
          entry.item,
          entry.addons,
          entry.notes
        );
      }}
    >
      {cartStore.quantity_map.get(entry.item.id)}
    </span>
  );
  let avail = cartStore.menuStore.isAvailable(item);
  if (!avail) {
    extratag = (
      <div className="itemNotAvail">
        {cartStore.menuStore.translation.not_available}
      </div>
    );
  }

  let itemNotes = [];
  if (cartStore.menuStore.layout === 4) {
    itemNotes = cartStore.getAddonsNamesList(entry.addons);
    let total = cartStore.entryTotal(entry);
    let { actualPrice, priceAmt } = cartStore.calculateRewardDiscoutPrice(
      entry.reward,
      total
    );
    // let spRequets=[];
    // if (entry.notes.length > 0) {
    // _.each(entry.notes, (note, index) => {
    // if (note !== '' && spRequets.length===0) { spRequets.push(note); }
    // });
    // }
    let reward = entry.reward;
    let rewardDiv = "";
    let isRwardItem = false;
    let isDisableCnt = false;
    if (!item.isInStock) {
      isDisableCnt = true;
    }
    if (reward && reward.redeem_code && reward.redeem_code !== "") {
      isRwardItem = true;
      isDisableCnt = true;
      rewardDiv = <div className="disNameBg">{reward.redeem_name}</div>;
    }
    return (
      <List>
        <Item
          wrap
          className="cart_item"
          thumb={
            <CartImg
              entry={entry}
              cartStore={cartStore}
              ind={ind}
              isRwardItem={isRwardItem}
            />
          }
        >
          <div className="cartItemName">
            <div className="innerItemName">
              <span className="cartItem">{item.name}</span>
              <span className="pricecart">
                <div
                  className="cartItemDelete"
                  onClick={() => {
                    alert(
                      <div className="cartItem"></div>,
                      <div
                        dangerouslySetInnerHTML={{
                          __html: cartStore.menuStore.htmlDecode(
                            cartStore.menuStore.translation.delete_item
                          ),
                        }}
                      />,
                      [
                        {
                          text: cartStore.menuStore.translation.close,
                        },
                        {
                          text: cartStore.menuStore.translation.yes,
                          onPress: () => {
                            cartStore.menuStore.sendGoogleAnalytics(
                              cartStore.menuStore.googleTrashItem,
                              entry.item.name,
                              cartStore.menuStore.controller,
                              entry.item.price * entry.addons.length * 100
                            );
                            //// console.log(ind);
                            cartStore.removeItemIndexWise(entry.item, ind);
                          },
                        },
                      ]
                    );
                  }}
                >
                  <FaTrashAlt color={"#666"} size={16} />
                </div>
                <Button
                  onClick={() => {
                    if (!isRwardItem) {
                      cartStore.menuStore.itemModal.showUpdateModal(
                        cartStore.entries[ind].item,
                        cartStore.entries[ind].addons,
                        cartStore.entries[ind].notes
                      );

                      //let {itemModal}=cartStore.menuStore;
                      cartStore.menuStore.itemModal.isVisible = 2;
                      cartStore.menuStore.openSetModal = true;
                    }
                  }}
                  className="editcartitem"
                  disabled={isRwardItem}
                >
                  edit
                </Button>
              </span>
            </div>
            {rewardDiv}
            <Brief>
              <RenderAddon addonSlected={entry.addons} />
              <RenderNotes entry={entry} />
            </Brief>
            <div className="innerStepperRow">
              <div className="cartSteper">
                <FoodStepper
                  value={entry.addons.length}
                  min={0}
                  onChange={throttle(
                    (quantity) => {
                      // cartStore.updateQuantity(entry, quantity);
                      // cartStore.resetEntries();
                      if (quantity > 0) {
                        if (quantity > entry.addons.length) {
                          cartStore.entries[ind].addons.push(entry.addons[0]);
                        } else {
                          cartStore.entries[ind].addons.pop();
                          cartStore.entries[ind].notes.pop();
                        }
                        cartStore.resetEntries();
                      }
                    },
                    250,
                    { maxWait: 1000 }
                  )}
                  disabled={isDisableCnt}
                  screen="cart"
                  checkQuanityError={checkQuanityError}
                  cartStore={cartStore}
                  item={item}
                />
              </div>
              {(() => {
                // Check if user is logged in
                const isLoggedIn =
                  cartStore.menuStore.isLoginModalVisible === false &&
                  cartStore.menuStore.social &&
                  Object.keys(cartStore.menuStore.social).length > 0;

                // Check if membership pricing should be used (similar to CartStore.entryTotal)
                const tokenExpiry = localStorage.getItem(
                  `${cartStore.menuStore.controller}_advocado_token_expiry`
                );
                const now = new Date().getTime();
                const useMembership = tokenExpiry && parseInt(tokenExpiry) > now;

                // Debug membership pricing conditions (disabled - too verbose)
                /*
                console.log('[CartItem Debug] Membership conditions:', {
                  itemName: item.name,
                  isLoggedIn: isLoggedIn,
                  useMembership: useMembership,
                  tokenExpiry: tokenExpiry,
                  now: now,
                  socialProvider: cartStore.menuStore.social && cartStore.menuStore.social.provider,
                });
                */

                // Calculate actual pricing including addons
                let standardTotal = 0;
                let membershipTotal = 0;
                
                const baseStandardPrice = parseFloat(item.price) || 0;
                const baseMembershipPrice = (item.membershipPrice && item.membershipPrice.price) 
                  ? parseFloat(item.membershipPrice.price) 
                  : baseStandardPrice;

                // Main item price for this entry (multiply by addon groups/quantity)
                standardTotal += baseStandardPrice * entry.addons.length;
                membershipTotal += baseMembershipPrice * entry.addons.length;

                // Calculate addon pricing including membership discounts
                if (entry.addons && entry.addons.length > 0) {
                  let addonStandardPrice = 0;
                  let addonMembershipPrice = 0;
                  
                  const firstAddonList = entry.addons[0];
                  if (firstAddonList) {
                    const keys = Object.keys(firstAddonList);
                    for (let i = 0; i < keys.length; i++) {
                      const category = keys[i];
                      if (category !== "undefined") {
                        for (let x = 0; x < firstAddonList[category].length; x++) {
                          const addon = firstAddonList[category][x];
                          
                          if (addon.quantity === 0) continue;
                          
                          const addonPrice = parseFloat(addon.price) || 0;
                          let membershipAddonPrice = addonPrice;
                          
                          // Check for stored membership pricing
                          if (addon.hasMembershipPricing && addon.membershipPrice !== undefined) {
                            membershipAddonPrice = parseFloat(addon.membershipPrice) || addonPrice;
                          } else {
                            // Fallback: Check for duplicate pattern (standard vs membership)
                            const sameNameAddons = firstAddonList[category].filter(a => a.name === addon.name && a.quantity > 0);
                            
                            if (sameNameAddons.length === 2) {
                              const prices = sameNameAddons.map(a => parseFloat(a.price)).sort((a, b) => b - a);
                              const standardPrice = prices[0];
                              const membershipPrice = prices[1];
                              
                              if (parseFloat(addon.price) === standardPrice) {
                                membershipAddonPrice = membershipPrice;
                              }
                            }
                          }
                          
                          addonStandardPrice += addonPrice * addon.quantity;
                          addonMembershipPrice += membershipAddonPrice * addon.quantity;
                        }
                      }
                    }
                    
                    // Multiply by number of addon groups
                    addonStandardPrice = addonStandardPrice * entry.addons.length;
                    addonMembershipPrice = addonMembershipPrice * entry.addons.length;
                  }
                  
                  // Add addon prices to totals
                  standardTotal += addonStandardPrice;
                  membershipTotal += addonMembershipPrice;
                }

                const hasMembershipPricing =
                  standardTotal > 0 &&
                  membershipTotal > 0 &&
                  standardTotal !== membershipTotal;

                // Debug final pricing calculation (disabled - too verbose)
                // console.log('[CartItem Debug] Final pricing:', {
                //   itemName: item.name,
                //   standardTotal: standardTotal,
                //   membershipTotal: membershipTotal,
                //   hasMembershipPricing: hasMembershipPricing,
                //   shouldShowDiscount: isLoggedIn && hasMembershipPricing,
                //   priceDifference: isLoggedIn && hasMembershipPricing ? standardTotal - membershipTotal : 0
                // });

                // Format price with currency symbol and 2 decimal places
                const formatPrice = (price) => {
                  return `${cartStore.menuStore.currencySymbol}${parseFloat(
                    price
                  ).toFixed(2)}`;
                };

                // Calculate price difference
                const priceDifference = isLoggedIn && hasMembershipPricing
                  ? standardTotal - membershipTotal
                  : 0;

                // If showing discounted price (from rewards, etc)
                if (actualPrice !== priceAmt) {
                  return (
                    <div className="price-container">
                      <div className="price-row">
                        <span className="original-price">
                          {formatPrice(actualPrice)}
                        </span>
                        <span className="discounted-price">
                          {formatPrice(priceAmt)}
                        </span>
                      </div>
                    </div>
                  );
                }

                // Regular price display with member price as standard
                return (
                  <div className="price-container">
                    <div className="price-row">
                      {(() => {
                        const shouldShowMemberPricing = isLoggedIn && hasMembershipPricing;
                        // console.log('[CartItem Debug] Display decision:', {
                        //   itemName: item.name,
                        //   shouldShowMemberPricing: shouldShowMemberPricing,
                        //   isLoggedIn: isLoggedIn,
                        //   hasMembershipPricing: hasMembershipPricing
                        // });
                        return shouldShowMemberPricing;
                      })() ? (
                        <div className="member-price-container">
                          <div className="member-price-display">
                            <span className="member-standard-price">
                              {formatPrice(standardTotal)}
                            </span>
                            {priceDifference > 0 && (
                              <div className="price-difference">
                                <span className="price-difference-amount">
                                  - {formatPrice(priceDifference)}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      ) : (
                        <span className="regular-price">
                          {formatPrice(priceAmt)}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        </Item>
      </List>
    );
  } else {
    let priceTx =
      parseFloat(item.price) === 0
        ? cartStore.menuStore.translation.price_zero
        : item.priceName;
    return (
      <List>
        <Item
          wrap
          className="cart_item"
          thumb={
            <CartImg
              entry={entry}
              cartStore={cartStore}
              ind={ind}
              isRwardItem={false}
            />
          }
          extra={extratag}
        >
          <div
            onClick={() => {
              cartStore.menuStore.itemModal.showUpdateModal(
                entry.item,
                entry.addons,
                entry.notes
              );
            }}
            className="cartItemName"
          >
            <div className="innerItemName">
              <p>{item.name}</p>
              <Brief>
                {isDisplayPrice && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: cartStore.menuStore.htmlDecode(priceTx),
                    }}
                  />
                )}
                {entry.hasNote && <FaPaperclip />}
                {itemNotes}
              </Brief>
            </div>
          </div>
        </Item>
        <CartItemAddon entry={entry} cartStore={cartStore} />
      </List>
    );
  }
});

const CartItemAddon = observer(({ entry, cartStore }) => {
  const { item, addons, notes } = entry;
  //// console.log(item.hasAddons,'tt');
  const template = [];
  // If the item has no addons, just skip addon portion
  if (item.hasAddons) {
    // Handle the items defauted in a set menu first (So it appears on the top)
    if (addons && "undefined" in addons) {
      _.each(addons["undefined"], (addon, index) => {
        template.push(
          <AddonFixed
            key={`fixed_${index}`}
            addon={addon}
            isCustomize={item.isCustomize}
            screen="cart"
          />
        );
      });
    }

    // Iterate through the cart which stores the items which contains the addons
    let checkIndex = cartStore.getAddonIndex(addons);
    let headingNum = 0;
    _.each(addons, (addonList, addonListIndex) => {
      let sQty = cartStore.getSetMealQty(addonList);
      if (sQty > 0) {
        headingNum++;
      }
      //// console.log(sQty,9);
      if (
        (item.isCustomize && addonListIndex === checkIndex) ||
        !item.isCustomize
      ) {
        template.push(
          <div
            id={`addon_${addonListIndex}_${item.id}`}
            key={addonListIndex}
            className={sQty > 0 ? "addonHeader" : "hideDiv addonHeader"}
          >
            {
              <span
                style={{ textAlign: "left", paddingRight: 6, fontSize: 12 }}
                onClick={() => {
                  entry.removeAddon(addonListIndex);
                  if (entry.addons.length === 0 || entry.item.isCustomize)
                    cartStore.removeItem(entry.item);
                  cartStore.resetEntries();
                }}
              >
                <FaTrashAlt />
              </span>
            }

            <span
              onClick={() => {
                cartStore.menuStore.itemModal.showUpdateModal(
                  item,
                  [addons[addonListIndex]],
                  [notes[addonListIndex]], // An array of notes array
                  (value) => {
                    notes[addonListIndex] = value;
                  }
                );
              }}
              className="setMealHeading"
              id={`addon_${addonListIndex}_${item.id}_heading`}
            >
              Set {headingNum}
            </span>

            <FiEdit
              style={{ position: "absolute", right: 9 }}
              onClick={() => {
                cartStore.menuStore.isSetMealEdit = true;
                cartStore.menuStore.itemModal.showUpdateModal(
                  item,
                  [addons[addonListIndex]],
                  [notes[addonListIndex]], // An array of notes array
                  (value) => {
                    notes[addonListIndex] = value;
                  }
                );
              }}
            />
          </div>
        );

        let keys = Object.keys(addonList);
        _.each(keys, (key, index) => {
          _.each(addonList[key], (addon, addonIndex) => {
            template.push(
              <AddonSummary
                key={`${addonListIndex}${index}_${addon.id}_${addonIndex}`}
                addon={addon}
                parentItem={item}
                isCustomize={item.isCustomize}
                screen="cart"
                cartStore={cartStore}
              />
            );
          });
        });
      }
    });
  }
  return template;
});

const CartImg = observer(({ entry, cartStore, ind, isRwardItem }) => {
  let layoutType = cartStore.menuStore.layout;
  let defaultImage = false;
  if (layoutType === 3) {
    defaultImage = entry.item.thumbnail.includes("/dish");
  }

  return (
    <div>
      {cartStore.menuStore.layout !== 4 && (
        <span
          // style={{ marginRight: "10px" }}
          className={defaultImage ? "" : "marginRight10"}
          onClick={() => {
            cartStore.menuStore.sendGoogleAnalytics(
              cartStore.menuStore.googleTrashItem,
              entry.item.name,
              cartStore.menuStore.controller,
              entry.item.price * entry.addons.length * 100
            );
            cartStore.removeItem(entry.item);
          }}
        >
          <FaTrashAlt color={"#666"} size={16} />
        </span>
      )}
      {!defaultImage ? (
        <img
          src={entry.item.thumbnail}
          alt=""
          onClick={() => {
            if (!isRwardItem) {
              if (cartStore.menuStore.layout === 4) {
                cartStore.menuStore.itemModal.showUpdateModal(
                  cartStore.entries[ind].item,
                  cartStore.entries[ind].addons,
                  cartStore.entries[ind].notes
                );
                cartStore.menuStore.openSetModal = true;
                let { itemModal } = cartStore.menuStore;
                itemModal.isVisible = 2;
              }

              cartStore.menuStore.itemModal.showUpdateModal(
                entry.item,
                entry.addons,
                entry.notes
              );
            }
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
});
function checkQuanityError(cartStore, item, qty) {
  let qty1 = qty;
  let isNextproceed = true;
  if (qty < 0) {
    let enty = cartStore.getEntry(item);
    qty1 = 1;
    if (enty) {
      qty = Math.abs(qty);
      let oldQty = cartStore.quantity_map.get(item.id);
      //// console.log(qty,'<',oldQty);
      if (qty < oldQty) {
        qty1 = 0;
        isNextproceed = false;
      }
    }
  }
  if (!isNextproceed) {
    return true;
  }
  let erroMsg = cartStore.checkQuantityValidation(item, qty1);
  if (erroMsg !== "") {
    alert(cartStore.menuStore.translation.error, erroMsg, [
      { text: "Close", onPress: () => {} },
    ]);
    return false;
  }
  return true;
}
export default Cart;
